export default {
  en: {
    changes: 'Changes',
    changeDate: 'Change Date',
    changedBy: 'Changed By',
    gameRatio: 'Game Ratio',
    gameTypes: 'Game Types',
    totalCurrentAmount: 'Total Current Amount',
    operatorIncome: 'Operator Income',
    playerExclusion: 'Player Exclusion',
    exclusionType: 'Exclusion Type',
    appliedBy: 'Applied By',
    totalFunds: 'Total Funds',
    operatorsIncome: 'Operators Income',
    totalAmountReturned: 'Total Amount Returned',
    totalAddedAmount: 'Total Added Amount',
    totalEarnedAmount: 'Total Earned Amount',
    balanceAdjustment: 'Balance Adjustment',
    playerFullName: 'Player First Name & Last Name',
    balanceAdjustmentDate: 'Balance Adjustment Date',
    fixedOddsTotalBetAmount: 'Fixed Odds Total Bet Amount',
    fixedOddsTotalWinAmount: 'Fixed Odds Total Win Amount',
    fixedOddsTotalLostAmount: 'Fixed Odds Total Lost Amount',
    fixedOddsBonusBetAmount: 'Fixed Odds Total Bonus Bet',
    casinoTotalBetAmount: 'Casino Games Total Bet Amount',
    casinoTotalWinAmount: 'Casino Games Total Win Amount',
    casinoTotalLostAmount: 'Casino Games Total Lost Amount',
    casinoBonusBetAmount: 'Casino Games Total Bonus Bet',
    sessionEndReason: 'Session End Reason',
    unsettledFundsAmount: 'Unsettled Funds Amount',
    safeServer: 'Safe Server',
    casinoGamesTotalBonusAmount: 'Casino Games Total Bonus Amount',
    fixedOddsTotalBonusAmount: 'Fixed Odds Total Bonus Amount',
    mirroringServer: 'Mirroring Server',
    logDate: 'Log Date',
    changeNotification: 'Change Notification',
    changeCategory: 'Change Category',
    changeDescription: 'Change Description',
    changeReason: 'Change Reason',
    previousVersion: 'Previous Version',
    currentVersion: 'Current Version',
    change: 'Change',
    inaccessibilityAreas: 'Inaccessibility Areas',
    inaccessibilityFrom: 'Inaccessibility From',
    inaccessibilityTo: 'Inaccessibility To',
    inaccessibilityReason: 'Inaccessibility Reason',
    reconnectionFailedAttempts: 'Reconnection Failed Attempts',
    serverName: 'Server Name',
    inaccessibilityDate: 'Inaccessibility Date',
    inaccessibilityServer: 'Inaccessibility Server',
    largeTransactionsInfo: 'The system is using the default conversion for this report, if you want to change the conversion you can do it from Brand Settings→Conversion Settings→Others',
    balanceAdjustmentCount: 'Balance Adjustment Count',
    selfExclusionCount: 'Self Exclusion Count',
    accountClosedCount: 'Account Closed Count',
    operatorInterventionCount: 'Operator Intervention Count',
    unusualEventsCount: 'Other Significant/Unusual Events Count',
    jackpotWinRatio: 'Jackpot Win Ratio',
    jackpotConfiguration: 'JackPot Configuration',
    jackpotName: 'Jackpot Name',
    gamePaylistId: 'Game Paylist ID',
    jackpotPrizeDate: 'Jackpot Prize Date',
    maximumJackpotLevel: 'Maximum Jackpot Level',
    jackpotAmount: 'Jackpot Amount',
    processingUserID: 'Processing User ID',
    processingUserName: 'Processing User Name',
    confirmingUserID: 'Confirming User ID',
    confirmingUserName: 'Confirming User Name',
    progressiveJackpotName: 'Progressive Jackpot Name',
    setupParameters: 'Setup Parameters',
    existingGamesPaylist: 'Existing Games Paylist',
    totalBetsAmount: 'Total Bets Amount',
    totalContributionsWinAmount: 'Total Contributions Win Amount',
    nonContributionFinance: 'Non Contribution Finance',
    jackpotPrizeCurrentAmount: 'Jackpot Prize Current Amount',
    jackpotContributionCurrentAmount: 'Jackpot Contribution Current Amount',
    terminationDate: 'Termination Date',
    maximumAwardedAmount: 'Maximum Awarded Amount',
    exceedingLimitAmount: 'Exceeding Limit Amount',
    promotionalItems: 'Promotional Items',
    promotionId: 'Promotion ID',
    promotionType: 'Promotion Type',
    totalBalanceAllocated: 'Total Balance Allocated',
    totalAmountPrizes: 'Total Amount - Prizes',
    totalAmountUsed: 'Total Amount Used',
    totalAdjustmentAmount: 'Total Adjustment Amount',
    finalBalance: 'Final Balance',
    softwareChanges: 'Software Changes',
    taxationDaily: 'Taxation Daily',
    taxationMonthly: 'Taxation Monthly',
    betWin: 'Bet Win',
    quarterDetails: 'Quarter Details',
    statisticalReportQuarter: 'Statistical Report Q{{quarter}} {{year}}',
    bettingSelfProtectionReportInfo: "The provided report is based on the Brand's timezone only, any time zone changes in this page will not affect the report",
    totalAmountExpired: 'Total Amount Expired',
    report: 'Report',
    exclusions: 'Exclusions',
    selectCriteriaToGenerateOrExportReport: 'Select criteria to generate or export report',
    run: 'Run',
    exclusionId: 'Exclusion ID',
    exclusionDurationCategory: 'Exclusion Duration Category',
    exclusionChannel: 'Exclusion Channel',
    exclusionRequestDate: 'Exclusion Request Date',
    expectedExclusionDuration: 'Expected Exclusion Duration',
    exclusionStartDate: 'Exclusion Start Date',
    endExclusionRequestDate: 'End Exclusion Request Date',
    exclusionEndDate: 'Exclusion End Date',
    exclusionReason: 'Exclusion Reason',
    reportCreationDate: 'Report Creation Date',
    reportUpdateDate: 'Report Update Date',
    resetFilters: 'Reset Filters',
    licenseeLegalName: 'Licensee Legal Name',
    licenseType: 'License Type',
    gameCategoryA: 'Game Category A',
    betCategoryB: 'Bet Category B',
    totalAmountWagered: 'Total Amount Wagered',
    totalAmountWageredSettled: 'Total Amount Wagered Settled',
    totalNumberPlayers: 'Total Number Players',
    totalNumberPlayersSettled: 'Total Number Players Settled',
    totalAmountWon: 'Total Amount Won',
    totalAmountWonJackpots: 'Total Amount Won Jackpots',
    totalNumberPlayersWon: 'Total Number Players Won',
    totalAmountWithholdingTax: 'Total Amount Withholding Tax',
    contribution345: 'Contribution345',
    contributionHGC05: 'ContributionHGC05',
    monthlyEconomic: 'Monthly Economic',
    month: 'Month',
    jackpotWinnings: 'Jackpot Winnings',
    jackpotID: 'Jackpot ID',
    jackpotType: 'Jackpot Type',
    jackpotStatus: 'Jackpot Status',
    profitDistributionLevelID: 'Profit Distribution Level ID',
    jackpotWonDate: 'Jackpot Won Date',
    totalJackpotWonAmount: 'Total Jackpot Won Amount',
    totalJackpotRake: 'Total Jackpot Rake',
    currency: 'Currency',
    ptPGameSessionID: 'Pt PGame Session ID',
    pokerTournamentID: 'Poker Tournament ID',
    jackpotPlayerAmount: 'Jackpot Player Amount',
    winningsCategory: 'Winnings Category',
    totalNumberCoupons: 'Total Number Coupons',
    playSession: 'Play Session',
    loginSessionStartDate: 'Login Session Start Date',
    loginSessionEndDate: 'Login Session End Date',
    loginSessionEndReason: 'Login Session Reason',
    channelIndicator: 'Channel Indicator',
    roamingIndicator: 'Roaming Indicator',
    beginningBalance: 'Beginning Balance',
    endingBalance: 'Ending Balance',
    reportDateFrom: 'Report Date From',
    reportDateTo: 'Report Date To',
    monthlyEconomicPlayerTaxes: 'Monthly Economic Player Taxes',
    totalNumberSessions: 'Total Number Sessions',
    monthlyEconomicBetting1: 'Monthly Economic Betting 1',
    betEventCategoryA: 'Bet Event Category A',
    limitCategory: 'Limit Category',
    limitCreationDate: 'Limit Creation Date',
    limitChangeDate: 'Limit Change Date',
    limitStartDate: 'Limit Start Date',
    newLimitDuration: 'New Limit Duration (hours)',
    newLimitAmount: 'New Limit Amount',
    oldLimitDuration: 'Old Limit Duration (hours)',
    oldLimitAmount: 'Old Limit Amount',
    limitInitiator: 'Limit Initiator',
    logInSessionId: 'Log In Session ID',
    gameSessions: 'Game Sessions',
    manufacturerLN: 'ManufacturerLN',
    totalRedeemableBonusAmount: 'Total Amount of Redeemable Bonuses',
    totalNonRedeemableBonusAmountWon: 'Total Non Redeemable Bonus Amount Won',
    totalNetAmountWon: 'Total Net Amount Won',
    totalPlayerAmountWon: 'Total Player Amount Won',
    totalNonRedeemableBonusAmountWagered: 'Total Non Redeemable Bonus Amount Wagered',
    totalAmountLicenseeRake: 'Total Licensee Rake',
    totalAmountJackpotRake: 'Total Jackpot Rake',
    monthlyGGR: 'Monthly GGR',
    licenseName: 'License Name',
    GGR: 'GGR',
    greekPublicParticipation: 'Greek Public Participation',
    resourceEEEP: 'Resource EEEP',
    hGCBetEventID: 'HGC Bet Event ID',
    betEventType: 'Bet Event Type',
    mainBetEventID: 'Main Bet Event ID',
    betEventCreationDate: 'Bet Event Creation Date',
    betEventResultDate: 'Bet Event Result Date',
    betEventCancellation: 'Bet Event Cancellation',
    betEventCancellationDate: 'Bet Event Cancellation Date',
    eventName: 'Event Name',
    eventType: 'Event Type',
    betEvents: 'Bet Events',
    betEventCategoryB: 'Bet Event Category B',
    betEventCategoryC: 'Bet Event Category C',
    betEventCategoryD: 'Bet Event Category D',
    bonusSchemas: 'Bonus Schemas',
    bonusStartDate: 'Bonus Start Date',
    bonusEndDate: 'Bonus End Date',
    givenNumberOfBonus: 'Given Number Of Bonus',
    givenBonusAmount: 'Given Bonus Amount',
    usedNumberOfBonus: 'Used Number Of Bonus',
    usedBonusAmount: 'Used Bonus Amount',
    bonusCategoryA: 'Bonus Category A',
    bonusCategoryB: 'Bonus Category B',
    wagerMultiplier: 'Wager Multiplier',
    amountWageredIndicator: 'Amount Wagered Indicator',
    otherWageringRequirements: 'Other Wagering Requirements',
    onlineAccounts: 'Online Accounts',
    accountType: 'Account Type',
    accountStatusDate: 'Account Status Date',
    accountStatusReason: 'Account Status Reason',
    surname: 'Surname',
    idNumber: 'Id Number',
    passportNumber: 'Passport Number',
    vatNumber: 'Vat Number',
    amkaNumber: 'Amka Number',
    addressCountry: 'Address Country',
    postCode: 'Post Code',
    emailAddress: 'Email Address',
    kycDate: 'Kyc Date',
    playersBetting: "Player's Betting",
    eventId: 'Event ID',
    betSettledPeriod: 'Bet Settled Period',
    betTypeB: 'Bet Type B',
    betStatus: 'Bet Status',
    betIp: 'Bet IP',
    playerRisk: 'Player Risk',
    betIdOdds: 'Bet ID Odds',
    betEventId: 'Bet Event ID',
    betEventName: 'Bet Event Name',
    betEventOdds: 'Bet Event Odds',
    betPlacedDate: 'Bet Placed Date',
    betSettlementDate: 'Bet Settlement Date',
    netAmountWon: 'Net Amount Won',
    withholdingTax2_5: 'Withholding Tax 2.5%',
    withholdingTax5: 'Withholding Tax 5%',
    withholdingTax7_5: 'Withholding Tax 7.5%',
    realMoneyWagers: 'Real Money Wagers',
    nonRedeemableBonuses: 'Non Redeemable Bonuses',
    realMoneyWinnings: 'Real Money Winnings',
    winningsFromNonRedeemableBonuses: 'Winnings From Non Redeemable Bonuses',
    bettingPerformance: 'Betting Performance',
    domainName: 'Domain Name',
    betType: 'Bet Type',
    totalNumberWagers: 'Total Number Wagers',
    totalNumberWagersSettled: 'Total Number Wagers Settled',
    totalNonRedeemableBonusAmountWageredSettled: 'Total Non Redeemable Bonus Amount Wagered Settled',
    recordType: 'RecordType',
    gamePerformanceDaily: 'Game Performance Daily',
    sharedLiquidityIndicator: 'shared Liquidity Indicator',
    totalNumberGameSessions: 'Total Number Of Game Sessions',
    totalNumberPokerCashGamesHands: 'Total Number Poker Cash Games Hands',
    totalNumberTaxationSessions: 'Total Number Of Taxation Sessions',
    totalNumberJackpots: 'Total Number Jackpots',
    totalNumberIncompleteGameSessions: 'Total Number Of Incomplete Game Sessions',
    bettingAndSelfProtection: 'Betting and Self-Protection',
    jackpotSettings: 'Jackpot Settings',
    jackpotProviderID: 'Jackpot Provider ID',
    profitDistributionLevelCount: 'Profit Distribution Level Count',
    increaseRate: 'Increase Rate',
    startUpAmount: 'Start Up Amount',
    amountJackpotLimitFloor: 'Amount Jackpot Limit Floor',
    amountJackpotLimitCeiling: 'Amount Jackpot Limit Ceiling',
    timeJackpotLimitCeiling: 'Time Jackpot Limit Ceiling',
    totalJackpotAmount: 'Total Jackpot Amount',
    paytableIDCount: 'Paytable ID Count',
    paytableID: 'Paytable ID',
    jackpotEndDate: 'Jackpot End Date',
    jackpotTransferedAmount: 'Jackpot Transfered Amount',
    oldProfitDistributionLevelID: 'Old Profit Distribution Level ID',
    newJackpotID: 'New Jackpot ID',
    newProfitDistributionLevelID: 'New Profit Distribution Level ID',
    jackpotTransferredDate: 'Jackpot Transferred Date',
    jackpotStartDate: 'Jackpot Start Date',
    totalExclusionCount: 'Total Exclusion Count',
    taxAmountPercent: 'Tax Amount ({{percent}}%)',
    totalBalances: 'Total Balances',
    companyProfit: 'Company Profit',
    balanceAvailable: 'Balance Available',
    nonRedeemableBonusAmountWagered: 'Non Redeemable Bonus Amount Wagered',
    totalWithholdingTax: 'Total Withholding Tax',
    nonRedeemableBonusAmountWon: 'Non Redeemable Bonus Amount Won',
    minimumWagerAmount: 'Minimum Wager Amount',
    withholdingTax15: 'Withholding Tax 15%',
    withholdingTax20: 'Withholding Tax 20%',
    addServer: 'Add Server',
    serverInaccessibility: 'Server Inaccessibility (Significant Events)',
    largeTransactions: 'Large Transactions (Significant Events)',
    restrictions: 'Restrictions (Significant Events)',
    ggrTaxAmount15: 'GGR Tax Amount (15%)',
    addChange: 'Add Change',
    tournament: 'Tournament',
    stake: 'Stake',
    mainEvent: 'Main Event',
    hampiExcludedPlayers: 'HAMPI Excluded Players',
    currentlyExcluded: 'Currently Excluded',
    total: 'Total',
    errorType: 'Error Type',
    resolution: 'Resolution',
    monthlyOperatorReport: 'Monthly Operator Report',
    addReport: 'Add Report',
    socialSecurityAmountCollected: 'Social Security Amount Collected',
    totalEducationAllocation: 'Total Education Allocation',
    basicEducationAllocation: 'Basic Education Allocation',
    technicalEducationAllocation: 'Technical Education Allocation',
    totalPublicSecurityAllocation: 'Total Public Security Allocation',
    fnspAllocation: 'FNSP Allocation',
    sisfronAllocation: 'SISFRON Allocation',
    totalSportAllocation: 'Total Sport Allocation',
    sinespAtletasAllocation: 'SINESP Atletas Allocation',
    cobAllocation: 'COB Allocation',
    cpbAllocation: 'CPB Allocation',
    cbcAllocation: 'CBC Allocation',
    cbdeAllocation: 'CBDE Allocation',
    cbduAllocation: 'CBDU Allocation',
    cbcpAllocation: 'CBCP Allocation',
    ministryOfSportAllocation: 'Ministry of Sport Allocation',
    sportsSecretariatAllocation: 'Sports Secretariat Allocation',
    cbemAllocation: 'CBEM Allocation',
    totalTourismAllocation: 'Total Tourism Allocation',
    embraturAllocation: 'Embratur Allocation',
    ministryOfTourismAllocation: 'Ministry of Tourism Allocation',
    healthAllocation: 'Health Allocation',
    fenapaesAllocation: 'FENAPAES Allocation',
    fenapestalozziAllocation: 'FENAPESTALOZZI Allocation',
    brazilianRedCrossAllocation: 'Brazilian Red Cross Allocation',
    funapolAllocation: 'FUNAPOL Allocation',
    abdiAllocation: 'ABDI Allocation',
    fiesAmountFromExpiredWinnings: 'FIES Amount From Expired Winnings',
    funcapAmountFromExpiredWinnings: 'FUNCAP Amount From Expired Winnings',
    inspectionFeeCollected: 'Inspection Fee Collected',
    rectificationReason: 'Rectification Reason',
    reportMonth: 'Report Month',
  },
  es: {
    changes: 'Cambios',
    changeDate: 'Fecha de modificación',
    changedBy: 'Modificado por',
    gameRatio: 'Ratio de juego',
    gameTypes: 'Tipos de juego',
    totalCurrentAmount: 'Importe total actual',
    operatorIncome: 'Ingresos de los operadores',
    playerExclusion: 'Exclusión de los jugadores',
    exclusionType: 'Tipo de exclusión',
    appliedBy: 'Aplicado por',
    totalFunds: 'Fondos totales',
    operatorsIncome: 'Ingresos de los operadores',
    totalAmountReturned: 'Importe total devuelto',
    totalAddedAmount: 'Importe total añadido',
    totalEarnedAmount: 'Importe total ganado',
    balanceAdjustment: 'Ajuste del saldo',
    playerFullName: 'Nombre y Apellidos del Jugador',
    balanceAdjustmentDate: 'Balance Fecha de ajuste',
    fixedOddsTotalBetAmount: 'Cuotas fijas Importe total de la apuesta',
    fixedOddsTotalWinAmount: 'Cuotas fijas Importe total de la ganancia',
    fixedOddsTotalLostAmount: 'Cuotas fijas Importe total perdido',
    fixedOddsBonusBetAmount: 'Cuotas fijas Total Bonificación Apuesta',
    casinoTotalBetAmount: 'Juegos de casino Importe total de la apuesta',
    casinoTotalWinAmount: 'Juegos de casino Importe total de ganancias',
    casinoTotalLostAmount: 'Juegos de casino Importe total perdido',
    casinoBonusBetAmount: 'Juegos de Casino Total Bono Apuesta',
    sessionEndReason: 'Motivo de la finalización de la sesión',
    unsettledFundsAmount: 'Importe de los fondos no liquidados',
    safeServer: 'Servidor Seguro',
    casinoGamesTotalBonusAmount: 'Juegos de Casino Importe Total de la Bonificación',
    fixedOddsTotalBonusAmount: 'Cuotas Fijas Importe Total de la Bonificación',
    mirroringServer: 'Servidor Espejo',
    logDate: 'Fecha de Registro',
    changeNotification: 'Notificación de Cambio',
    changeCategory: 'Categoría de Cambio',
    changeDescription: 'Descripción del Cambio',
    changeReason: 'Razón del Cambio',
    previousVersion: 'Versión Anterior',
    currentVersion: 'Versión Actual',
    change: 'Cambio',
    inaccessibilityAreas: 'Ýreas de Inaccesibilidad',
    inaccessibilityFrom: 'Inaccesibilidad Desde',
    inaccessibilityTo: 'Inaccesibilidad Hasta',
    inaccessibilityReason: 'Razón de Inaccesibilidad',
    reconnectionFailedAttempts: 'Intentos Fallidos de Reconexión',
    serverName: 'Nombre del Servidor',
    inaccessibilityDate: 'Fecha de Inaccesibilidad',
    inaccessibilityServer: 'Servidor de Inaccesibilidad',
    largeTransactionsInfo:
      'El sistema está utilizando la conversión predeterminada para este informe; si deseas cambiar la conversión, puedes hacerlo desde Configuración de Marca → Configuración de Conversión → Otros',
    balanceAdjustmentCount: 'Conteo de Ajuste de Balance',
    selfExclusionCount: 'Conteo de Autoexclusión',
    accountClosedCount: 'Conteo de Cuenta Cerrada',
    operatorInterventionCount: 'Conteo de Intervención del Operador',
    unusualEventsCount: 'Conteo de Otros Eventos Significativos/Inusuales',
    jackpotWinRatio: 'Cociente de Ganancias de Jackpot',
    jackpotConfiguration: 'Configuración de Jackpot',
    jackpotName: 'Nombre del Jackpot',
    gamePaylistId: 'ID de la Lista de Juegos',
    jackpotPrizeDate: 'Fecha del Premio del Jackpot',
    maximumJackpotLevel: 'Nivel Máximo del Jackpot',
    jackpotAmount: 'Importe del Jackpot',
    processingUserID: 'ID de Usuario de Procesamiento',
    processingUserName: 'Nombre de Usuario de Procesamiento',
    confirmingUserID: 'ID de Usuario de Confirmación',
    confirmingUserName: 'Nombre de Usuario de Confirmación',
    progressiveJackpotName: 'Nombre del Jackpot Progresivo',
    setupParameters: 'Parámetros de Configuración',
    existingGamesPaylist: 'Lista de Juegos Existente',
    totalBetsAmount: 'Importe Total de Apuestas',
    totalContributionsWinAmount: 'Importe Total de Contribuciones Ganadoras',
    nonContributionFinance: 'Finanzas de No Contribución',
    jackpotPrizeCurrentAmount: 'Importe Actual del Premio del Jackpot',
    jackpotContributionCurrentAmount: 'Importe Actual de Contribución del Jackpot',
    terminationDate: 'Fecha de Terminación',
    maximumAwardedAmount: 'Importe Máximo Otorgado',
    exceedingLimitAmount: 'Importe que Excede el Límite',
    promotionalItems: 'Artículos Promocionales',
    promotionId: 'ID de Promoción',
    promotionType: 'Tipo de Promoción',
    totalBalanceAllocated: 'Balance Total Asignado',
    totalAmountPrizes: 'Importe Total - Premios',
    totalAmountUsed: 'Importe Total Utilizado',
    totalAdjustmentAmount: 'Importe Total de Ajuste',
    finalBalance: 'Balance Final',
    softwareChanges: 'Cambios de Software',
    taxationDaily: 'Impuestos Diarios',
    taxationMonthly: 'Impuestos Mensuales',
    betWin: 'Ganancia de Apuesta',
    quarterDetails: 'Detalles del Trimestre',
    statisticalReportQuarter: 'Informe Estadístico Q{{trimestre}} {{año}}',
    bettingSelfProtectionReportInfo: 'El informe proporcionado se basa únicamente en la zona horaria de la Marca; cualquier cambio en la zona horaria en esta página no afectará el informe',
    serverInaccessibility: 'Inaccesibilidad del Servidor (Hechos Relevantes)',
    largeTransactions: 'Grandes transacciones (Hechos Relevantes)',
    restrictions: 'Restricciones (Hechos Relevantes)',
    totalAmountExpired: 'Monto total expirado',
    report: 'Informe',
    exclusions: 'Exclusiones',
    selectCriteriaToGenerateOrExportReport: 'Seleccione criterios para generar o exportar el informe',
    run: 'Ejecutar',
    exclusionId: 'ID de exclusión',
    exclusionDurationCategory: 'Categoría de duración de exclusión',
    exclusionChannel: 'Canal de exclusión',
    exclusionRequestDate: 'Fecha de solicitud de exclusión',
    expectedExclusionDuration: 'Duración esperada de exclusión',
    exclusionStartDate: 'Fecha de inicio de exclusión',
    endExclusionRequestDate: 'Fecha de fin de solicitud de exclusión',
    exclusionEndDate: 'Fecha de fin de exclusión',
    exclusionReason: 'Motivo de exclusión',
    reportCreationDate: 'Fecha de creación del informe',
    reportUpdateDate: 'Fecha de actualización del informe',
    resetFilters: 'Restablecer filtros',
    licenseeLegalName: 'Nombre legal del licenciatario',
    licenseType: 'Tipo de licencia',
    gameCategoryA: 'Categoría de juego A',
    betCategoryB: 'Categoría de apuesta B',
    totalAmountWagered: 'Monto total apostado',
    totalAmountWageredSettled: 'Monto total apostado liquidado',
    totalNumberPlayers: 'Número total de jugadores',
    totalNumberPlayersSettled: 'Número total de jugadores liquidados',
    totalAmountWon: 'Monto total ganado',
    totalAmountWonJackpots: 'Monto total ganado en jackpots',
    totalNumberPlayersWon: 'Número total de jugadores ganadores',
    totalAmountWithholdingTax: 'Monto total de retención fiscal',
    contribution345: 'Contribución345',
    contributionHGC05: 'ContribuciónHGC05',
    monthlyEconomic: 'Económico mensual',
    month: 'Mes',
    jackpotWinnings: 'Ganancias de jackpot',
    jackpotID: 'ID de jackpot',
    jackpotType: 'Tipo de jackpot',
    jackpotStatus: 'Estado del jackpot',
    profitDistributionLevelID: 'ID de nivel de distribución de beneficios',
    jackpotWonDate: 'Fecha de jackpot ganado',
    totalJackpotWonAmount: 'Monto total ganado en jackpot',
    totalJackpotRake: 'Comisión total de jackpot',
    currency: 'Moneda',
    ptPGameSessionID: 'ID de sesión de juego Pt PGame',
    pokerTournamentID: 'ID de torneo de póker',
    jackpotPlayerAmount: 'Monto de jugador en jackpot',
    winningsCategory: 'Categoría de ganancias',
    totalNumberCoupons: 'Número total de cupones',
    playSession: 'Sesión de juego',
    loginSessionStartDate: 'Fecha de inicio de sesión',
    loginSessionEndDate: 'Fecha de fin de sesión',
    loginSessionEndReason: 'Motivo de sesión',
    channelIndicator: 'Indicador de canal',
    roamingIndicator: 'Indicador de roaming',
    beginningBalance: 'Saldo inicial',
    endingBalance: 'Saldo final',
    reportDateFrom: 'Informe desde fecha',
    reportDateTo: 'Informe hasta fecha',
    monthlyEconomicPlayerTaxes: 'Impuestos económicos mensuales de jugadores',
    totalNumberSessions: 'Número total de sesiones',
    monthlyEconomicBetting1: 'Apuesta económica mensual 1',
    betEventCategoryA: 'Categoría de evento de apuesta A',
    limitCategory: 'Categoría de límite',
    limitCreationDate: 'Fecha de creación del límite',
    limitChangeDate: 'Fecha de cambio del límite',
    limitStartDate: 'Fecha de inicio del límite',
    newLimitDuration: 'Nueva duración de límite (horas)',
    newLimitAmount: 'Nuevo monto límite',
    oldLimitDuration: 'Duración anterior del límite (horas)',
    oldLimitAmount: 'Monto límite anterior',
    limitInitiator: 'Iniciador del límite',
    logInSessionId: 'ID de sesión de inicio de sesión',
    gameSessions: 'Sesiones de juego',
    manufacturerLN: 'Nombre del fabricante',
    totalRedeemableBonusAmount: 'Monto total de bonos canjeables',
    totalNonRedeemableBonusAmountWon: 'Monto total ganado en bonos no canjeables',
    totalNetAmountWon: 'Monto neto total ganado',
    totalPlayerAmountWon: 'Monto total ganado por jugadores',
    totalNonRedeemableBonusAmountWagered: 'Monto total apostado de bonos no canjeables',
    totalAmountLicenseeRake: 'Comisión total del licenciatario',
    totalAmountJackpotRake: 'Comisión total de jackpot',
    monthlyGGR: 'GGR mensual (Ingresos netos del juego)',
    licenseName: 'Nombre de la licencia',
    GGR: 'Ingresos netos del juego',
    greekPublicParticipation: 'Participación pública griega',
    resourceEEEP: 'Recurso EEEP',
    hGCBetEventID: 'ID de evento de apuesta HGC',
    betEventType: 'Tipo de evento de apuesta',
    mainBetEventID: 'ID principal de evento de apuesta',
    betEventCreationDate: 'Fecha de creación de evento de apuesta',
    betEventResultDate: 'Fecha de resultado de evento de apuesta',
    betEventCancellation: 'Cancelación de evento de apuesta',
    betEventCancellationDate: 'Fecha de cancelación de evento de apuesta',
    eventName: 'Nombre del evento',
    eventType: 'Tipo de evento',
    betEvents: 'Eventos de apuesta',
    betEventCategoryB: 'Categoría de evento de apuesta B',
    betEventCategoryC: 'Categoría de evento de apuesta C',
    betEventCategoryD: 'Categoría de evento de apuesta D',
    bonusSchemas: 'Esquemas de bonos',
    bonusStartDate: 'Fecha de inicio del bono',
    bonusEndDate: 'Fecha de fin del bono',
    givenNumberOfBonus: 'Número dado de bonos',
    givenBonusAmount: 'Monto dado de bonos',
    usedNumberOfBonus: 'Número usado de bonos',
    usedBonusAmount: 'Monto usado de bonos',
    bonusCategoryA: 'Categoría de bono A',
    bonusCategoryB: 'Categoría de bono B',
    wagerMultiplier: 'Multiplicador de Wager',
    amountWageredIndicator: 'Indicador de monto apostado',
    otherWageringRequirements: 'Otros requisitos de apuesta',
    onlineAccounts: 'Cuentas Online',
    accountType: 'Tipo de cuenta',
    accountStatusDate: 'Fecha de estado de cuenta',
    accountStatusReason: 'Motivo de estado de cuenta',
    surname: 'Apellido',
    idNumber: 'Número de identificación',
    passportNumber: 'Número de pasaporte',
    vatNumber: 'Número de IVA',
    amkaNumber: 'Número AMKA',
    addressCountry: 'País de dirección',
    postCode: 'Código postal',
    emailAddress: 'Dirección de correo electrónico',
    kycDate: 'Fecha KYC',
    playersBetting: 'Apuestas del jugador',
    eventId: 'ID de evento',
    betSettledPeriod: 'Periodo de liquidación de apuesta',
    betTypeB: 'Tipo de apuesta B',
    betStatus: 'Estado de apuesta',
    betIp: 'IP de apuesta',
    playerRisk: 'Riesgo del jugador',
    betIdOdds: 'Cuotas de ID de apuesta',
    betEventId: 'ID de evento de apuesta',
    betEventName: 'Nombre de evento de apuesta',
    betEventOdds: 'Cuota de evento de apuesta',
    betPlacedDate: 'Fecha de apuesta realizada',
    betSettlementDate: 'Fecha de liquidación de apuesta',
    netAmountWon: 'Monto neto ganado',
    withholdingTax2_5: 'Retención fiscal 2.5%',
    withholdingTax5: 'Retención fiscal 5%',
    withholdingTax7_5: 'Retención fiscal 7.5%',
    realMoneyWagers: 'Wager con dinero real',
    nonRedeemableBonuses: 'Bonos no canjeables',
    realMoneyWinnings: 'Ganancias con dinero real',
    winningsFromNonRedeemableBonuses: 'Ganancias de bonos no canjeables',
    bettingPerformance: 'Rendimiento de apuestas',
    domainName: 'Nombre de Domain',
    betType: 'Tipo de apuesta',
    totalNumberWagers: 'Número total de apuestas',
    totalNumberWagersSettled: 'Número total de wagers liquidadas',
    totalNonRedeemableBonusAmountWageredSettled: 'Monto total apostado de bonos no canjeables liquidados',
    recordType: 'Tipo de registro',
    gamePerformanceDaily: 'Rendimiento diario del juego',
    sharedLiquidityIndicator: 'Indicador de liquidez compartida',
    totalNumberGameSessions: 'Número total de sesiones de juego',
    totalNumberPokerCashGamesHands: 'Número total de manos de póker cash',
    totalNumberTaxationSessions: 'Número total de sesiones de tributación',
    totalNumberJackpots: 'Número total de jackpots',
    totalNumberIncompleteGameSessions: 'Número total de sesiones de juego incompletas',
    bettingAndSelfProtection: 'Apuestas y autoprotección',
    jackpotSettings: 'Configuración de jackpot',
    jackpotProviderID: 'ID del proveedor de jackpot',
    profitDistributionLevelCount: 'Conteo de nivel de distribución de beneficios',
    increaseRate: 'Tasa de incremento',
    startUpAmount: 'Monto inicial',
    amountJackpotLimitFloor: 'Monto límite inferior de jackpot',
    amountJackpotLimitCeiling: 'Monto límite superior de jackpot',
    timeJackpotLimitCeiling: 'Tiempo límite superior de jackpot',
    totalJackpotAmount: 'Monto total del jackpot',
    paytableIDCount: 'Conteo de ID de tabla de pagos',
    paytableID: 'ID de tabla de pagos',
    jackpotEndDate: 'Fecha de fin de jackpot',
    jackpotTransferedAmount: 'Monto transferido de jackpot',
    oldProfitDistributionLevelID: 'ID antiguo de nivel de distribución de beneficios',
    newJackpotID: 'Nuevo ID de jackpot',
    newProfitDistributionLevelID: 'Nuevo ID de nivel de distribución de beneficios',
    jackpotTransferredDate: 'Fecha de transferencia de jackpot',
    jackpotStartDate: 'Fecha de inicio de jackpot',
    totalExclusionCount: 'Conteo total de exclusiones',
    taxAmountPercent: 'Monto de impuesto ({{percent}}%)',
    totalBalances: 'Saldos totales',
    companyProfit: 'Ganancia de la compañía',
    balanceAvailable: 'Saldo disponible',
    nonRedeemableBonusAmountWagered: 'Monto apostado de bonos no canjeables',
    totalWithholdingTax: 'Total de retención fiscal',
    nonRedeemableBonusAmountWon: 'Monto ganado de bonos no canjeables',
    minimumWagerAmount: 'Monto Mínimo de Wager',
    withholdingTax15: 'Retención fiscal 15%',
    withholdingTax20: 'Retención fiscal 20%',
    addServer: 'Añadir servidor',
    ggrTaxAmount15: 'Monto de impuesto GGR (15 %)',
    addChange: 'Añadir cambio',
    tournament: 'Torneo',
    stake: 'Apuesta',
    mainEvent: 'Evento principal',
    total: 'Total',
  },
  tr: {
    changes: 'Değişiklikler',
    changeDate: 'Değişim Tarihi',
    changedBy: 'Değiştiren',
    gameRatio: 'Oyun Oranı',
    gameTypes: 'Oyun Türleri',
    totalCurrentAmount: 'Toplam Mevcut Tutar',
    operatorIncome: 'Operatör Geliri',
    playerExclusion: 'Oyuncu Hariç Tutma',
    exclusionType: 'Hariç Tutma Türü',
    appliedBy: 'Uygulayan',
    totalFunds: 'Toplam Fon Miktarı',
    operatorsIncome: 'Operatörlerin Geliri',
    totalAmountReturned: 'İade Edilen Toplam Tutar',
    totalAddedAmount: 'Toplam Eklenen Tutar',
    totalEarnedAmount: 'Toplam Kazanılan Tutar',
    balanceAdjustment: 'Bakiye Düzenleme',
    playerFullName: 'Oyuncu Adı & Soyadı',
    balanceAdjustmentDate: 'Bakiye Düzenleme Tarihi',
    fixedOddsTotalBetAmount: 'Sabit Oranlı Toplam Bahis Tutarı',
    fixedOddsTotalWinAmount: 'Sabit Oranlı Toplam Kazanç Miktarı',
    fixedOddsTotalLostAmount: 'Sabit Oranlı Toplam Kayıp Tutarı',
    fixedOddsBonusBetAmount: 'Sabit Oranlı Toplam Bonus Bahsi',
    casinoTotalBetAmount: 'Casino Oyunları Toplam Bahis Tutarı',
    casinoTotalWinAmount: 'Casino Oyunları Toplam Kazanç Miktarı',
    casinoTotalLostAmount: 'Casino Oyunları Toplam Kayıp Tutarı',
    casinoBonusBetAmount: 'Casino Oyunları Toplam Bonus Bahsi',
    sessionEndReason: 'Oturum Bitiş Nedeni',
    unsettledFundsAmount: 'Ödenmemiş Fon Tutarı',
    safeServer: 'Güvenli Sunucu',
    casinoGamesTotalBonusAmount: 'Casino Oyunları Toplam Bonus Tutarı',
    fixedOddsTotalBonusAmount: 'Sabit Oran Toplam Bonus Tutarı',
    mirroringServer: 'Yansıtma Sunucusu',
    logDate: 'Kayıt Tarihi',
    changeNotification: 'Bildirimi Değiştir',
    changeCategory: 'Kategoriyi Değiştir',
    changeDescription: 'Açıklamayı Değiştir',
    changeReason: 'Nedeni Değiştir',
    previousVersion: 'Önceki Sürüm',
    currentVersion: 'Güncel Sürüm',
    change: 'Değiştir',
    inaccessibilityAreas: 'Erişilmezlik Alanları',
    inaccessibilityFrom: 'Erişilemezlik Tarihinden',
    inaccessibilityTo: 'Erişilemezlik Tarihine',
    inaccessibilityReason: 'Erişilmezlik Nedeni',
    reconnectionFailedAttempts: 'Yeniden Bağlantı Başarısız Girişimler',
    serverName: 'Sunucu Adı',
    inaccessibilityDate: 'Erişilmezlik Tarihi',
    inaccessibilityServer: 'Erişilmezlik Sunucusu',
    largeTransactionsInfo: 'Sistem bu rapor için varsayılan çevrimi kullanmaktadır, eğer çevrimi değiştirmek isterseniz bunu Marka Ayarları→Çevrim Ayarları→Diğer bölümünden yapabilirsiniz.',
    balanceAdjustmentCount: 'Bakiye Ayarlama Sayısı',
    selfExclusionCount: 'Kendini Hariç Tutma Sayısı',
    accountClosedCount: 'Hesap Kapatma Sayısı',
    operatorInterventionCount: 'Operatör Müdahale Sayısı',
    unusualEventsCount: 'Diğer Önemli/ Sıradışı Etkinlikler Sayısı',
    jackpotWinRatio: 'Jackpot Kazanma Oranı',
    jackpotConfiguration: 'JackPot Yapılandırması',
    jackpotName: 'Jackpot Adı',
    gamePaylistId: 'Oyun Ödeme Listesi ID',
    jackpotPrizeDate: 'Jackpot Ödül Tarihi',
    maximumJackpotLevel: 'Maksimum Jackpot Seviyesi',
    jackpotAmount: 'Jackpot Tutarı',
    processingUserID: 'Kullanıcı ID işleme',
    processingUserName: 'Kullanıcı Adı İşleme',
    confirmingUserID: 'Kullanıcı ID Onaylama',
    confirmingUserName: 'Kullanıcı Adı Onaylama',
    progressiveJackpotName: 'Progressive Jackpot Adı',
    setupParameters: 'Parametreleri Ayarla',
    existingGamesPaylist: 'Mevcut Oyunlar Ödeme Listesi',
    totalBetsAmount: 'Toplam Bahis Tutarı',
    totalContributionsWinAmount: 'Toplam Katkı Kazanç Tutarı',
    nonContributionFinance: 'Katılım Sağlamayan Finans',
    jackpotPrizeCurrentAmount: 'Jackpot Ödülü Güncel Tutar',
    jackpotContributionCurrentAmount: 'Jackpot Katkısı Güncel Tutar',
    terminationDate: 'Sonlandırma Tarihi',
    maximumAwardedAmount: 'Maksimum Ödül Tutarı',
    exceedingLimitAmount: 'Limit Aşımı Tutarı',
    promotionalItems: 'Promosyon Öğeleri',
    promotionId: 'Promosyon ID',
    promotionType: 'Promosyon Türü',
    totalBalanceAllocated: 'Dağıtılan Toplam Bakiye',
    totalAmountPrizes: 'Toplam Tutar - Ödüller',
    totalAmountUsed: 'Toplam Kullanılan Tutar',
    totalAdjustmentAmount: 'Toplam Düzeltme Tutarı',
    finalBalance: 'Son Bakiye',
    softwareChanges: 'Yazılım Değişiklikleri',
    taxationDaily: 'Günlük Vergilendirme',
    taxationMonthly: 'Aylık Vergilendirme',
    betWin: 'Bahis Kazanç',
    quarterDetails: 'Çeyrek Detaylar',
    statisticalReportQuarter: 'İstatistiksel Rapor Q{{quarter}} {{year}}',
    bettingSelfProtectionReportInfo: 'Sağlanan rapor yalnızca Markanın saat dilimine göre verilmiştir, bu sayfadaki herhangi bir saat dilimi değişikliği raporu etkilemez',
    serverInaccessibility: 'Sunucu Erişilemezliği (Önemli Etkinlikler)',
    largeTransactions: 'Büyük İşlemler (Önemli Etkinlikler)',
    restrictions: 'Sınırlamalar (Önemli Etkinlikler)',
    totalAmountExpired: 'Süresi Dolan Toplam Tutar',
    report: 'Rapor',
    exclusions: 'Hariç tutulanlar',
    selectCriteriaToGenerateOrExportReport: 'Rapor oluşturmak veya dışa aktarmak için kriterleri seçin',
    run: 'Çalıştır',
    exclusionId: 'Hariç Tutulan ID',
    exclusionDurationCategory: 'Hariç Tutulma Süresi Kategorisi',
    exclusionChannel: 'Hariç Tutma Kanalı',
    exclusionRequestDate: 'Hariç Tutma Talebi Tarihi',
    expectedExclusionDuration: 'Beklenen Hariç Tutma Süresi',
    exclusionStartDate: 'Hariç Tutma Başlangıç Tarihi',
    endExclusionRequestDate: 'Hariç Tutma Talebinin Bitiş Tarihi',
    exclusionEndDate: 'Hariç Tutma Bitiş Tarihi',
    exclusionReason: 'Hariç Tutma Nedeni',
    reportCreationDate: 'Rapor Oluşturma Tarihi',
    reportUpdateDate: 'Rapor Güncelleme Tarihi',
    resetFilters: 'Filtreleri Sıfırla',
    licenseeLegalName: 'Lisans Sahibinin Yasal Unvanı',
    licenseType: 'Lisans Türü',
    gameCategoryA: 'Oyun Kategorisi A',
    betCategoryB: 'Bahis Kategorisi B',
    totalAmountWagered: 'Toplam Bahis Tutarı',
    totalAmountWageredSettled: 'Toplam Bahis Tutarı Ödenen',
    totalNumberPlayers: 'Toplam Oyuncu Sayısı',
    totalNumberPlayersSettled: 'Toplam Oyuncu Sayısı Ödenen',
    totalAmountWon: 'Toplam Kazanılan Tutar',
    totalAmountWonJackpots: 'Toplam Kazanılan Tutar Jackpotlar',
    totalNumberPlayersWon: 'Toplam Kazanan Oyuncu Sayısı',
    totalAmountWithholdingTax: 'Toplam Tutar Vergi Kesintisi',
    contribution345: 'Katkı345',
    contributionHGC05: 'KatkıHGC05',
    monthlyEconomic: 'Aylık Ekonomi',
    month: 'Ay',
    jackpotWinnings: 'Jackpot Kazançları',
    jackpotID: 'Jackpot ID',
    jackpotType: 'Jackpot Türü',
    jackpotStatus: 'Jackpot Durumu',
    profitDistributionLevelID: 'Kâr Dağıtım Seviyesi ID',
    jackpotWonDate: 'Jackpot Kazanma Tarihi',
    totalJackpotWonAmount: 'Toplam Kazanılan Jackpot Tutarı',
    totalJackpotRake: 'Toplam Jackpot Komisyonu',
    currency: 'Döviz Türü',
    ptPGameSessionID: 'Pt PGame Oturum ID',
    pokerTournamentID: 'Poker Turnuvası ID',
    jackpotPlayerAmount: 'Jackpot Oyuncu Tutarı',
    winningsCategory: 'Kazanç Kategorisi',
    totalNumberCoupons: 'Toplam Kupon Sayısı',
    playSession: 'Oyun Oturumu',
    loginSessionStartDate: 'Oturum Açma Başlangıç Tarihi',
    loginSessionEndDate: 'Oturum Açma Bitiş Tarihi',
    loginSessionEndReason: 'Oturum Açma Nedeni',
    channelIndicator: 'Kanal Göstergesi',
    roamingIndicator: 'Roaming Göstergesi',
    beginningBalance: 'Başlangıç Bakiyesi',
    endingBalance: 'Bitiş Bakiyesi',
    reportDateFrom: 'Rapor Başlangıç Tarihi',
    reportDateTo: 'Rapor Bitiş Tarihi',
    monthlyEconomicPlayerTaxes: 'Aylık Ekonomik Oyuncu Vergileri',
    totalNumberSessions: 'Toplam Oturum Sayısı',
    monthlyEconomicBetting1: 'Aylık Ekonomik Bahis 1',
    betEventCategoryA: 'Bahis Etkinliği Kategorisi A',
    limitCategory: 'Limit Kategorisi',
    limitCreationDate: 'Limit Oluşturma Tarihi',
    limitChangeDate: 'Limit Değişikliği Tarihi',
    limitStartDate: 'Limit Başlangıç Tarihi',
    newLimitDuration: 'Yeni Limit Süresi (saat)',
    newLimitAmount: 'Yeni Limit Tutarı',
    oldLimitDuration: 'Eski Limit Süresi (saat)',
    oldLimitAmount: 'Eski Limit Tutarı',
    limitInitiator: 'Limit Başlatıcı',
    logInSessionId: "Oturum ID'si ile Giriş Yap",
    gameSessions: 'Oyun Oturumları',
    manufacturerLN: 'ÜreticiLN',
    totalRedeemableBonusAmount: 'Toplam Aktarılacak Bonus Tutarı',
    totalNonRedeemableBonusAmountWon: 'Toplam Aktarılamaz Bonus Kazanç Tutarı',
    totalNetAmountWon: 'Toplam Net Kazanç Tutarı',
    totalPlayerAmountWon: 'Toplam Oyuncu Kazanç Tutarı',
    totalNonRedeemableBonusAmountWagered: 'Toplam Aktarılamaz Çevrilen Bonus Tutarı',
    totalAmountLicenseeRake: 'Lisans Sahibi Toplam Komisyon',
    totalAmountJackpotRake: 'Toplam Jackpot Komisyonu',
    monthlyGGR: 'Aylık GGR',
    licenseName: 'Lisans Adı',
    GGR: 'GGR',
    greekPublicParticipation: 'Yunan Halk Katılımı',
    resourceEEEP: 'Kaynak EEEP',
    hGCBetEventID: 'HGC Bahis Etkinlik ID',
    betEventType: 'Bahis Etkinlik Türü',
    mainBetEventID: 'Ana Bahis Etkinlik ID',
    betEventCreationDate: 'Bahis Etkinliği Oluşturma Tarihi',
    betEventResultDate: 'Bahis Etkinliği Sonuç Tarihi',
    betEventCancellation: 'Bahis Etkinliği İptali',
    betEventCancellationDate: 'Bahis Etkinliği İptal Tarihi',
    eventName: 'Etkinlik Adı',
    eventType: 'Etkinlik Türü',
    betEvents: 'Bahis Etkinlikleri',
    betEventCategoryB: 'Bahis Etkinliği',
    betEventCategoryC: 'Bahis Etkinlik Kategorisi C',
    betEventCategoryD: 'Bahis Etkinlik Kategorisi D',
    bonusSchemas: 'Bonus Şemaları',
    bonusStartDate: 'Bonus Başlangıç Tarihi',
    bonusEndDate: 'Bonus Bitiş Tarihi',
    givenNumberOfBonus: 'Verilen Bonus Sayısı',
    givenBonusAmount: 'Verilen Bonus Tutarı',
    usedNumberOfBonus: 'Kullanılan Bonus Sayısı',
    usedBonusAmount: 'Kullanılan Bonus Tutarı',
    bonusCategoryA: 'Bonus Kategorisi A',
    bonusCategoryB: 'Bonus Kategorisi B',
    wagerMultiplier: 'Çevrim Çarpanı',
    amountWageredIndicator: 'Çevrilen Tutar Göstergesi',
    otherWageringRequirements: 'Diğer Çevrim Şartları',
    onlineAccounts: 'Çevrimiçi Hesaplar',
    accountType: 'Hesap Türü',
    accountStatusDate: 'Hesap Durumu Tarihi',
    accountStatusReason: 'Hesap Durumu Nedeni',
    surname: 'Soyadı',
    idNumber: 'Id Numarası',
    passportNumber: 'Pasaport Numarası',
    vatNumber: 'KDV Numarası',
    amkaNumber: 'Amka Numarası',
    addressCountry: 'Adres Ülke',
    postCode: 'Posta Kodu',
    emailAddress: 'E-posta Adresi',
    kycDate: 'Kyc Tarihi',
    playersBetting: 'Oyuncu Bahisleri',
    eventId: 'Etkinlik ID',
    betSettledPeriod: 'Bahis Ödeme Süresi',
    betTypeB: 'Bahis Türü B',
    betStatus: 'Bahis Durumu',
    betIp: 'Bahis IP',
    playerRisk: 'Oyuncu Riski',
    betIdOdds: 'Bahis ID Oranlar',
    betEventId: 'Bahis Etkinlik ID',
    betEventName: 'Bahis Etkinlik Adı',
    betEventOdds: 'Bahis Etkinlik Oranları',
    betPlacedDate: 'Bahis Yapılan Tarih',
    betSettlementDate: 'Bahis Ödeme Tarihi',
    netAmountWon: 'Net Kazanç Tutarı',
    withholdingTax2_5: 'Vergi Kesintisi %2,5',
    withholdingTax5: 'Vergi kesintisi %5',
    withholdingTax7_5: 'Vergi Kesintisi %7,5',
    realMoneyWagers: 'Real Para Çevrimleri',
    nonRedeemableBonuses: 'Aktarılmayan Bonuslar',
    realMoneyWinnings: 'Real Para Kazançları',
    winningsFromNonRedeemableBonuses: 'Aktarılmayan Bonuslardan Kazançlar',
    bettingPerformance: 'Bahis Performansı',
    domainName: 'Domain Adı',
    betType: 'Bahis Türü',
    totalNumberWagers: 'Toplam Çevrim Sayısı',
    totalNumberWagersSettled: 'Toplam Ödenen Bahis Sayısı',
    totalNonRedeemableBonusAmountWageredSettled: 'Toplam Aktarılmayan Çevrilen Ödenen Bonus Tutarı',
    recordType: 'Kayıt Türü',
    gamePerformanceDaily: 'Oyun Performansı Günlük',
    sharedLiquidityIndicator: 'Paylaşılan Likidite Göstergesi',
    totalNumberGameSessions: 'Toplam Oyun Oturumu Sayısı',
    totalNumberPokerCashGamesHands: 'Toplam Poker Nakit Oyunları El Sayısı',
    totalNumberTaxationSessions: 'Toplam Vergi Oturumu Sayısı',
    totalNumberJackpots: 'Toplam Jackpot Sayısı',
    totalNumberIncompleteGameSessions: 'Tamamlanmamış Oyun Oturumlarının Toplam Sayısı',
    bettingAndSelfProtection: 'Bahis ve Kendini Koruma',
    jackpotSettings: 'Jackpot Ayarları',
    jackpotProviderID: 'Jackpot Sağlayıcı ID',
    profitDistributionLevelCount: 'Kâr Dağıtım Seviyesi Sayısı',
    increaseRate: 'Artış Oranı',
    startUpAmount: 'Başlangıç Tutarı',
    amountJackpotLimitFloor: 'Tutar Jackpot Limit Taban',
    amountJackpotLimitCeiling: 'Tutar Jackpot Limiti Tavan',
    timeJackpotLimitCeiling: 'Zaman Jackpot Limiti Tavanı',
    totalJackpotAmount: 'Toplam Jackpot Tutarı',
    paytableIDCount: 'Ödeme tablosu ID sayısı',
    paytableID: 'Ödeme tablosu ID ',
    jackpotEndDate: 'Jackpot Bitiş Tarihi',
    jackpotTransferedAmount: 'Jackpot Transfer Edilen Tutar',
    oldProfitDistributionLevelID: 'Eski Kar Dağıtım Seviyesi ID',
    newJackpotID: 'Yeni Jackpot ID',
    newProfitDistributionLevelID: 'Yeni Kar Dağıtım Seviyesi ID',
    jackpotTransferredDate: 'Jackpot Transfer Tarihi',
    jackpotStartDate: 'Jackpot Başlangıç Tarihi',
    totalExclusionCount: 'Toplam Hariç Tutma Sayısı',
    taxAmountPercent: 'Vergi Tutarı ({{percent}}%)',
    totalBalances: 'Toplam Bakiyeler',
    companyProfit: 'Şirket Karı',
    balanceAvailable: 'Kullanılabilir Bakiye',
    nonRedeemableBonusAmountWagered: 'Toplam Aktarılmayan Çevrilen Bonus Tutarı',
    totalWithholdingTax: 'Toplam Vergi Kesintisi',
    nonRedeemableBonusAmountWon: 'Aktarılmayan Kazanılan Bonus Tutarı',
    minimumWagerAmount: 'Minimum Çevrim Tutarı',
    withholdingTax15: 'Vergi kesintisi %15',
    withholdingTax20: 'Vergi kesintisi %20',
    addServer: 'Sunucu Ekle',
    ggrTaxAmount15: 'GGR Vergi Tutarı (15%)',
  },
  ru: {
    changes: 'Изменения',
    changeDate: 'Дата изменений',
    changedBy: 'Изменено (кем)',
    gameRatio: 'Коэффициент игры',
    gameTypes: 'Типы игр',
    totalCurrentAmount: 'Общая текущая сумма',
    operatorIncome: 'Доход оператора',
    playerExclusion: 'Исключение игрока',
    exclusionType: 'Тип исключений',
    appliedBy: 'Применено (кем)',
    total: 'Всего',
    totalFunds: 'Всего средств',
    operatorsIncome: 'Доход операторов',
    totalAmountReturned: 'Общая сумма возврата средств',
    totalAddedAmount: 'Всего добавленная сумма',
    totalEarnedAmount: 'Всего заработанная сумма',
    balanceAdjustment: 'Пополнение баланса',
    playerFullName: 'Имя и фамилия игрока',
    balanceAdjustmentDate: 'Дата пополнениѝ баланса',
    fixedOddsTotalBetAmount: 'Общая сумма ставок по фиксированным коэффициентам',
    fixedOddsTotalWinAmount: 'Общая сумма выигрышей по фиксированным коэффициентам',
    fixedOddsTotalLostAmount: 'Общая сумма проигрышей по фиксированным коэффициентам',
    fixedOddsBonusBetAmount: 'Всего бонусных ставок по фиксированным коэффициентам',
    casinoTotalBetAmount: 'Общая сумма ставок в казино играх',
    casinoTotalWinAmount: 'Общая сумма выигрышей в казино играх',
    casinoTotalLostAmount: 'Общая сумма проигрышей в казино играх',
    casinoBonusBetAmount: 'Всего сумма бонусных ставок в казино играх',
    sessionEndReason: 'Причина завершения сессии',
    unsettledFundsAmount: 'Сумма нераспределенных средств',
    safeServer: 'Безопасный сервер',
    casinoGamesTotalBonusAmount: 'Общая сумма бонуса в играх казино',
    fixedOddsTotalBonusAmount: 'Общая сумма бонуса и фиксированных коэффициентов',
    mirroringServer: 'Зеркальный сервер',
    logDate: ' Дата лога',
    changeNotification: 'Уведомление об изменениях',
    changeCategory: 'Категория изменений',
    changeDescription: 'Описание изменений',
    changeReason: 'Причина изменений',
    previousVersion: 'Предыдущая версия',
    currentVersion: 'Текущая версия',
    change: 'Изменить',
    inaccessibilityAreas: 'Недоступные зоны',
    inaccessibilityFrom: 'Недоступность от',
    inaccessibilityTo: 'Недоступность',
    inaccessibilityReason: 'Причина недоступности',
    reconnectionFailedAttempts: 'Неудачные попытки повторного подключениѝ',
    serverName: 'Название сервера',
    inaccessibilityDate: 'Дата недоступности',
    inaccessibilityServer: 'Сервер недоступности',
    largeTransactionsInfo:
      'Система использует конвертацию по умолчанию для этого отчета, если вы хотите изменить конвертацию, вы можете сделать это в разделе Настройки бренда→Настройки конвертации→Другие',
    balanceAdjustmentCount: 'Подсчет корректировки баланса',
    selfExclusionCount: 'Подсчет самоисключений',
    accountClosedCount: 'Подсчет закрытых счетов',
    operatorInterventionCount: 'Подсчет вмешательств оператора',
    unusualEventsCount: 'Подсчет других важных/необычных событий ',
    jackpotWinRatio: 'Коэффициент выигрыша джекпота',
    jackpotConfiguration: 'Конфигурация джекпота',
    jackpotName: 'Название джекпота',
    gamePaylistId: 'ID игрового пейлиста',
    jackpotPrizeDate: 'Дата розыгрыша джекпота',
    maximumJackpotLevel: 'Максимальный уровень джекпота',
    jackpotAmount: 'Сумма джекпота',
    processingUserID: 'Обработка ID пользователя',
    processingUserName: 'Обработка имени пользователя',
    confirmingUserID: 'Подтверждение ID пользователя',
    confirmingUserName: 'Подтверждение имени пользователя',
    progressiveJackpotName: 'Название прогрессивного джекпота',
    setupParameters: 'Параметры настройки',
    existingGamesPaylist: 'Пейлист существующих игр',
    totalBetsAmount: 'Общая сумма ставок',
    totalContributionsWinAmount: 'Сумма выигрыша общих взносов ',
    nonContributionFinance: 'Финансирование без взносов ',
    jackpotPrizeCurrentAmount: 'Текущая сумма розыгрыша джекпота ',
    jackpotContributionCurrentAmount: 'Текущая сумма взноса в джекпот',
    terminationDate: 'Дата окончаниѝ',
    maximumAwardedAmount: 'Максимальнаѝ сумма вознаграждений',
    exceedingLimitAmount: 'Превышение суммы лимита',
    promotionalItems: 'Промо-материалы',
    promotionId: 'ID промоакции',
    promotionType: 'Тип промоакции',
    totalBalanceAllocated: 'Итого распределенный остаток',
    totalAmountPrizes: 'Итоговая сумма — призы',
    totalAmountUsed: 'Всего использованная сумма',
    totalAdjustmentAmount: 'Всего сумма корректировки',
    finalBalance: 'Итоговый баланс',
    softwareChanges: 'Изменения в программном обеспечении',
    taxationDaily: ' Ежедневное налогообложение',
    taxationMonthly: ' Ежемесяччное налогообложение',
    betWin: 'Выигрыш по ставке',
    quarterDetails: 'Подробности квартала',
    statisticalReportQuarter: 'Статистический отчет Q{{квартал}} {{год}}',
    bettingSelfProtectionReportInfo: 'Предоставленный отчет основан только на часовом поясе бренда, любые изменениѝ часового пояса на этой странице не повлияют на отчет',
    serverInaccessibility: 'Недоступность сервера (Важные события)',
    largeTransactions: 'Крупные транзакции (Важные события)',
    restrictions: 'Ограничения (Важные события)',
    totalAmountExpired: 'Общая просроченная сумма',
    report: 'Отчет',
    exclusions: 'Исключения',
    selectCriteriaToGenerateOrExportReport: 'Выберите критерии для создания или экспорта отчета',
    run: 'Запуск',
    exclusionId: 'ID исключения',
    exclusionDurationCategory: 'Категория продолжительности исключения',
    exclusionChannel: 'Канал исключения',
    exclusionRequestDate: 'Дата запроса на исключение',
    expectedExclusionDuration: 'Ожидаемая продолжительность исключения',
    exclusionStartDate: 'Дата начала исключения',
    endExclusionRequestDate: 'Дата запроса на прекращение исключения',
    exclusionEndDate: 'Дата прекращения исключения',
    exclusionReason: 'Причина исключения',
    reportCreationDate: 'Дата создания отчета',
    reportUpdateDate: 'Дата обновления отчета',
    resetFilters: 'Сбросить фильтры',
    licenseeLegalName: 'Юридическое имя владельца лицензии',
    licenseType: 'Тип лицензии',
    gameCategoryA: 'Игра категории A',
    betCategoryB: 'Ставка категории B',
    totalAmountWagered: 'Общая сумма вейджера',
    totalAmountWageredSettled: 'Урегулированная общая сумма вейджера',
    totalNumberPlayers: 'Общее количество игроков',
    totalNumberPlayersSettled: 'Урегулированное бщее количество игроков',
    totalAmountWon: 'Общая сумма выигрыша',
    totalAmountWonJackpots: 'Общая сумма выигранных джекпотов',
    totalNumberPlayersWon: 'Общее количество побед игроков',
    totalAmountWithholdingTax: 'Общая сумма удержанного налога',
    contribution345: 'Вклад345',
    contributionHGC05: 'ВкладHGC05',
    monthlyEconomic: 'Ежемесячный экономический',
    month: 'Месяц',
    jackpotWinnings: 'Выигрыш джекпота',
    jackpotID: 'ID джекпота',
    jackpotType: 'Тип джекпота',
    jackpotStatus: 'Статус джекпота',
    profitDistributionLevelID: 'ID уровня распределения прибыли',
    jackpotWonDate: 'Дата выигрыша джекпота',
    totalJackpotWonAmount: 'Общая сумма выигранного джекпота',
    totalJackpotRake: 'Общий рейк джекпота',
    currency: 'Валюта',
    ptPGameSessionID: 'ID сессии Pt PGame ',
    pokerTournamentID: 'ID покерного турнира',
    jackpotPlayerAmount: 'Сумма джекпота игрока',
    winningsCategory: 'Категория выигрышей',
    totalNumberCoupons: 'Общее количество купонов',
    playSession: 'Игровая сессия',
    loginSessionStartDate: 'Дата начала сессии входа в систему',
    loginSessionEndDate: 'Дата окончания сессии входа в систему',
    loginSessionEndReason: 'Причина сессии входа в систему',
    channelIndicator: 'Индикатор канала',
    roamingIndicator: 'Индикатор роуминга',
    beginningBalance: 'Начальный баланс',
    endingBalance: 'Конечный баланс',
    reportDateFrom: 'Дата отчета от',
    reportDateTo: 'Дата отчета до',
    monthlyEconomicPlayerTaxes: 'Ежемесячные экономические налоги игроков',
    totalNumberSessions: 'Общее количество сессий',
    monthlyEconomicBetting1: 'Ежемесячные экономические ставки 1',
    betEventCategoryA: 'Ставка на событие категории A',
    limitCategory: 'Категория лимита',
    limitCreationDate: 'Дата создания лимита',
    limitChangeDate: 'Дата изменения лимита',
    limitStartDate: 'Дата начала лимита',
    newLimitDuration: 'Продолжительность нового лимита (часы)',
    newLimitAmount: 'Сумма нового лимита',
    oldLimitDuration: 'Продолжительность старого лимита (часы)',
    oldLimitAmount: 'Сумма старого лимита',
    limitInitiator: 'Инициатор лимита',
    logInSessionId: 'ID сессии входа в систему',
    gameSessions: 'Игровые сессии',
    manufacturerLN: 'ПроизводительLN',
    totalRedeemableBonusAmount: 'Общая сумма выкупаемых бонусов',
    totalNonRedeemableBonusAmountWon: 'Общая сумма выигранных бонусов без права выкупа',
    totalNetAmountWon: 'Общая чистая сумма выигрыша',
    totalPlayerAmountWon: 'Общая сумма выигрыша игрока',
    totalNonRedeemableBonusAmountWagered: 'Общая сумма невыкупаемых бонусов-вейджеров',
    totalAmountLicenseeRake: 'Общий рейк лицензиатов',
    totalAmountJackpotRake: 'Общий рейк джекпота',
    monthlyGGR: 'Ежемесячный GGR',
    licenseName: 'Название лицензии',
    GGR: 'GGR',
    greekPublicParticipation: 'Участие греческого общества',
    resourceEEEP: 'EEEP ресурса',
    hGCBetEventID: 'ID беттинг-события HGC',
    betEventType: 'Тип беттинг-события',
    mainBetEventID: 'ID основного беттинг-события',
    betEventCreationDate: 'Дата создания беттинг-события',
    betEventResultDate: 'Дата результата беттинг-события',
    betEventCancellation: 'Отмена беттинг-события',
    betEventCancellationDate: 'Дата отмены беттинг-события',
    eventName: 'Название события',
    eventType: 'Тип события',
    betEvents: 'Беттинг-события',
    betEventCategoryB: 'Беттинг-событие категории B',
    betEventCategoryC: 'Беттинг-событие категории C',
    betEventCategoryD: 'Беттинг-событие категории D',
    bonusSchemas: 'Бонусные схемы',
    bonusStartDate: 'Дата начала бонусов',
    bonusEndDate: 'Дата окончания бонусов',
    givenNumberOfBonus: 'Заданное количество бонусов',
    givenBonusAmount: 'Заданная сумма бонусов',
    usedNumberOfBonus: 'Использованное количество бонусов',
    usedBonusAmount: 'Использованная сумма бонусов',
    bonusCategoryA: 'Бонус категории A',
    bonusCategoryB: 'Бонус категории B',
    wagerMultiplier: 'Мультипликатор вейджера',
    amountWageredIndicator: 'Индикатор вейджер-суммы',
    otherWageringRequirements: 'Другие требования к вейджерингу',
    onlineAccounts: 'Онлайн-аккаунты',
    accountType: 'Тип аккаунта',
    accountStatusDate: 'Дата состояния аккаунта',
    accountStatusReason: 'Причина состояния аккаунта',
    surname: 'Фамилия',
    idNumber: 'ID номер',
    passportNumber: 'Номер паспорта',
    vatNumber: 'Номер НДС',
    amkaNumber: 'Номер Amka',
    addressCountry: 'Страна-адресат',
    postCode: 'Почтовый индекс',
    emailAddress: 'Адрес эл. почты',
    kycDate: 'Дата KYC',
    playersBetting: 'Ставки игрока',
    eventId: 'ID события',
    betSettledPeriod: 'Период расчета ставки',
    betTypeB: 'Ставка типа B',
    betStatus: 'Статус ставки',
    betIp: 'IP ставки',
    playerRisk: 'Риск игрока',
    betIdOdds: 'Коэффициенты ID ставки',
    betEventId: 'ID беттинг-события',
    betEventName: 'Название беттинг-события',
    betEventOdds: 'Коэффициенты беттинг-события',
    betPlacedDate: 'Дата размещения ставки',
    betSettlementDate: 'Дата расчета ставки',
    netAmountWon: 'Чистая сумма выигрыша',
    withholdingTax2_5: 'Удерживаемый налог 2,5%',
    withholdingTax5: 'Удерживаемый налог 5%',
    withholdingTax7_5: 'Удерживаемый налог 7,5%',
    realMoneyWagers: 'Вейджеры на реальные деньги',
    nonRedeemableBonuses: 'Невыкупаемые бонусы',
    realMoneyWinnings: 'Реальные денежные выигрыши',
    bettingPerformance: 'Результативность ставок',
    domainName: 'Название домена',
    betType: 'Тип ставки',
    totalNumberWagers: 'Общее количество вейджеров',
    totalNumberWagersSettled: 'Общее количество сыгранных вейджеров',
    totalNonRedeemableBonusAmountWageredSettled: 'Общая невыкупаемая бонусная сумма сыгранного вейджера',
    recordType: 'Тип записи',
    gamePerformanceDaily: 'Ежедневная производительность игры',
    sharedLiquidityIndicator: 'Индикатор общей ликвидности',
    totalNumberGameSessions: 'Общее количество игровых сессий',
    totalNumberPokerCashGamesHands: 'Общее количество рук в покерных играх на деньги',
    totalNumberTaxationSessions: 'Общее количество сессий по налогообложению',
    totalNumberJackpots: 'Общее количество джекпотов',
    totalNumberIncompleteGameSessions: 'Общее количество незавершенных игровых сессий',
    bettingAndSelfProtection: 'Ставки и самозащита',
    jackpotSettings: 'Настройки джекпота',
    jackpotProviderID: 'ID провайдера джекпота',
    profitDistributionLevelCount: 'Подсчет уровня распределения прибыли',
    startUpAmount: 'Повышение',
    amountJackpotLimitFloor: 'Минимальный лимит суммы джекпота',
    amountJackpotLimitCeiling: 'Максимальный лимит суммы джекпота',
    timeJackpotLimitCeiling: 'Максимальный лимит джекпота по времени',
    totalJackpotAmount: 'Общая сумма джекпота',
    paytableIDCount: 'Счетчик ID платежных таблиц',
    paytableID: 'ID платежной таблицы',
    jackpotEndDate: 'Дата окончания джекпота',
    jackpotTransferedAmount: 'Переданная сумма джекпота',
    oldProfitDistributionLevelID: 'ID уровня распределения старой прибыли',
    newJackpotID: 'ID нового джекпота',
    newProfitDistributionLevelID: 'ID уровня распределения новой прибыли',
    jackpotTransferredDate: 'Дата передачи джекпота',
    jackpotStartDate: 'Дата начала джекпота',
    totalExclusionCount: 'Общее количество исключений',
    taxAmountPercent: 'Сумма налога ({{percent}}%)',
    totalBalances: 'Итого остаток',
    companyProfit: 'Прибыль компании',
    balanceAvailable: 'Доступный баланс',
    nonRedeemableBonusAmountWagered: 'Невыкупаемая бонусная сумма вейджера',
    totalWithholdingTax: 'Итого удержанный налог',
    nonRedeemableBonusAmountWon: 'Выигранная невыкупаемая бонусная сумма',
    withholdingTax15: 'Удерживаемый налог 15%',
    withholdingTax20: 'Удерживаемый налог 20%',
    addServer: 'Добавить сервер',
    winningsFromNonRedeemableBonuses: 'Выигрыши от невыкупаемых бонусов',
    increaseRate: 'Темп роста',
    minimumWagerAmount: 'Минимальная сумма вейджера',
    ggrTaxAmount15: 'Сумма налога GGR (15%)',
    addChange: 'Добавить изменение',
    tournament: 'Турнир',
    stake: 'Ставка',
    mainEvent: 'Главное событие',
  },
  pt: {
    changes: 'Alterações',
    changeDate: 'Data da Alteração',
    changedBy: 'Alterado por',
    gameRatio: 'Proporção do Jogo',
    gameTypes: 'Tipos de Jogos',
    totalCurrentAmount: 'Valor Total Atual',
    operatorIncome: 'Rendimento do Operador',
    playerExclusion: 'Exclusão do Jogador',
    exclusionType: 'Tipo de Exclusão',
    appliedBy: 'Aplicado por',
    totalFunds: 'Total de Fundos',
    operatorsIncome: 'Rendimento dos Operadores',
    totalAmountReturned: 'Valor Total Devolvido',
    totalAddedAmount: 'Valor Total Adicionado',
    totalEarnedAmount: 'Valor Total Ganho',
    balanceAdjustment: 'Ajuste do Saldo',
    playerFullName: 'Primeiro e Último Nome do Jogador',
    balanceAdjustmentDate: 'Data do Ajuste do Saldo',
    fixedOddsTotalBetAmount: 'Odds Fixas Valor Total da Aposta',
    fixedOddsTotalWinAmount: 'Odds Fixas Valor Total Ganho',
    fixedOddsTotalLostAmount: 'Odds Fixas Valor Total Perdido',
    fixedOddsBonusBetAmount: 'Odds Fixas Aposta Total de Bônus',
    casinoTotalBetAmount: 'Jogos de Cassino Valor Total da Aposta',
    casinoTotalWinAmount: 'Jogos de Cassino Valor Total Ganho',
    casinoTotalLostAmount: 'Jogos de Cassino Valor Total Perdido',
    casinoBonusBetAmount: 'Jogos de Cassino Aposta Total de Bônus',
    sessionEndReason: 'Motivo do Fim da Sessão',
    unsettledFundsAmount: 'Valor Não Resolvido de Fundos',
    safeServer: 'Servidor Seguro',
    casinoGamesTotalBonusAmount: 'Valor Total do Bônus de Jogos de Cassino',
    fixedOddsTotalBonusAmount: 'Valor Total do Bônus de Odds Fixas',
    mirroringServer: 'Servidor Espelho',
    logDate: 'Data de Registro',
    changeNotification: 'Notificação de alteração',
    changeCategory: 'Categoria de alteração',
    changeDescription: 'Alterar Descrição',
    changeReason: 'Alterar Motivo',
    previousVersion: 'Versão anterior',
    currentVersion: 'Versão atual',
    change: 'Alteração',
    inaccessibilityAreas: 'Zonas de inacessibilidade',
    inaccessibilityFrom: 'Inacessibilidade de',
    inaccessibilityTo: 'Inacessibilidade para',
    inaccessibilityReason: 'Motivo da inacessibilidade',
    reconnectionFailedAttempts: 'Tentativas de reconexão falhadas',
    serverName: 'Nome do servidor',
    inaccessibilityDate: 'Data de inacessibilidade',
    inaccessibilityServer: 'Servidor de Inacessibilidade',
    largeTransactionsInfo:
      'O sistema está a utilizar a conversão predefinida para este relatório. Se pretender alterar a conversão, pode fazê-lo a partir de Definições da marca → Definições de conversão → Outros',
    balanceAdjustmentCount: 'Contagem de ajustamento do saldo',
    selfExclusionCount: 'Contagem de auto-exclusão',
    accountClosedCount: 'Contagem de contas encerradas',
    operatorInterventionCount: 'Contagem de intervenções do operador',
    unusualEventsCount: 'Contagem de outros acontecimentos significativos/incomuns ',
    jackpotWinRatio: 'Proporção de ganhos do jackpot',
    jackpotConfiguration: 'Configuração do Jackpot',
    jackpotName: 'Nome do Jackpot',
    gamePaylistId: 'ID da lista de pagamento do jogo',
    jackpotPrizeDate: 'Data do prêmio do jackpot',
    maximumJackpotLevel: 'Nível máximo do jackpot',
    jackpotAmount: 'Valor do jackpot',
    processingUserID: 'Processamento do ID do usuário',
    processingUserName: 'Processamento do nome do usuário',
    confirmingUserID: 'Confirmação do ID do usuário',
    confirmingUserName: 'Confirmação do nome do usuário',
    progressiveJackpotName: 'Nome do jackpot progressivo',
    setupParameters: 'Parâmetros de configuração',
    existingGamesPaylist: 'Lista de jogos existente',
    totalBetsAmount: 'Valor total de apostas',
    totalContributionsWinAmount: '\nTotal das Contribuições Montante de Ganho',
    nonContributionFinance: 'Financiamento sem contribuição',
    jackpotPrizeCurrentAmount: 'Valor atual do prêmio do jackpot',
    jackpotContributionCurrentAmount: 'Valor atual da contribuição do jackpot',
    terminationDate: 'Data de término',
    maximumAwardedAmount: 'Valor máximo atribuído',
    exceedingLimitAmount: 'Valor que excede o limite',
    promotionalItems: 'Itens promocionais',
    promotionId: 'ID da promoção',
    promotionType: 'Tipo de promoção',
    totalBalanceAllocated: 'Saldo Total Atribuído',
    totalAmountPrizes: 'Valor total - Prêmios',
    totalAmountUsed: 'Valor total utilizado',
    totalAdjustmentAmount: 'Valor total de ajuste',
    finalBalance: 'Saldo final',
    softwareChanges: 'Alterações de software',
    taxationDaily: 'Tributação diária',
    taxationMonthly: 'Tributação mensal',
    betWin: 'Ganho de aposta',
    quarterDetails: 'Detalhes do trimestre',
    statisticalReportQuarter: 'Relatório estatístico Q{{quarter}} {{year}}',
    bettingSelfProtectionReportInfo: 'O relatório fornecido baseia-se apenas no fuso horário da Marca, quaisquer alterações de fuso horário nesta página não afectarão o relatório',
    serverInaccessibility: 'Inacessibilidade do servidor (Eventos significativos)',
    largeTransactions: 'Grandes Transações (Eventos significativos)',
    restrictions: 'Restrições (Eventos significativos)',
    totalAmountExpired: 'Valor total expirado',
    report: 'Relatório',
    exclusions: 'Exclusões',
    selectCriteriaToGenerateOrExportReport: 'Selecione critérios para gerar ou exportar relatório',
    run: 'Executar',
    exclusionId: 'ID de Exclusão',
    exclusionDurationCategory: 'Categoria de duração de exclusão',
    exclusionChannel: 'Canal de exclusão',
    exclusionRequestDate: 'Data de solicitação de exclusão',
    expectedExclusionDuration: 'Duração prevista da exclusão',
    exclusionStartDate: 'Data de início da exclusão',
    endExclusionRequestDate: 'Data de término da solicitação de exclusão',
    exclusionEndDate: 'Data de término da exclusão',
    exclusionReason: 'Motivo da exclusão',
    reportCreationDate: 'Data de criação do relatório',
    reportUpdateDate: 'Data de atualização do relatório',
    resetFilters: 'Redefinir filtros',
    licenseeLegalName: 'Nome legal do licenciado',
    licenseType: 'Tipo de licença',
    gameCategoryA: 'Categoria de jogo A',
    betCategoryB: 'Categoria de aposta B',
    totalAmountWagered: 'Valor total apostado',
    totalAmountWageredSettled: 'Valor total apostado liquidado',
    totalNumberPlayers: 'Número total de jogadores',
    totalNumberPlayersSettled: 'Número total de jogadores liquidados',
    totalAmountWon: 'Valor total ganho',
    totalAmountWonJackpots: 'Valor total ganho em jackpots',
    totalNumberPlayersWon: 'Número total de jogadores vencedores',
    totalAmountWithholdingTax: 'Valor total do imposto retido na fonte',
    contribution345: 'Contribuição345',
    contributionHGC05: 'ContribuiçãoHGC05',
    monthlyEconomic: 'Economia mensal',
    month: 'Mês',
    jackpotWinnings: 'Ganhos do Jackpot',
    jackpotID: 'ID do Jackpot',
    jackpotType: 'Tipo de Jackpot',
    jackpotStatus: 'Status do Jackpot',
    profitDistributionLevelID: 'ID do nível de distribuição de lucro',
    jackpotWonDate: 'Data de ganho do jackpot',
    totalJackpotWonAmount: 'Valor total do jackpot ganho',
    totalJackpotRake: 'Comissão total do jackpot',
    currency: 'Moeda',
    ptPGameSessionID: 'ID da sessão Pt PGame',
    pokerTournamentID: 'ID do torneio de pôquer',
    jackpotPlayerAmount: 'Valor do Jogador do Jackpot',
    winningsCategory: 'Categoria de ganhos',
    totalNumberCoupons: 'Total de cupons',
    playSession: 'Sessão de jogo',
    loginSessionStartDate: 'Data de início da sessão de login',
    loginSessionEndDate: 'Data de término da sessão de login',
    loginSessionEndReason: 'Motivo da sessão de login',
    channelIndicator: 'Indicador de canal',
    roamingIndicator: 'Indicador de Roaming',
    beginningBalance: 'Saldo inicial',
    endingBalance: 'Saldo final',
    reportDateFrom: 'Data do relatório de',
    reportDateTo: 'Data do relatório até',
    monthlyEconomicPlayerTaxes: 'Impostos econômicos mensais do jogador',
    totalNumberSessions: 'Número total de sessões',
    monthlyEconomicBetting1: 'Apostas econômicas mensais 1',
    betEventCategoryA: 'Categoria de evento de aposta A',
    limitCategory: 'Categoria de limite',
    limitCreationDate: 'Data de criação limite',
    limitChangeDate: 'Data de alteração do limite',
    limitStartDate: 'Data de início do limite',
    newLimitDuration: 'Novo limite de duração (horas)',
    newLimitAmount: 'Novo valor limite',
    oldLimitDuration: 'Duração do limite antigo (horas)',
    oldLimitAmount: 'Valor do limite antigo',
    limitInitiator: 'Iniciador de limite',
    logInSessionId: 'ID da sessão de login',
    gameSessions: 'Sessões de jogo',
    manufacturerLN: 'FabricanteLN',
    totalRedeemableBonusAmount: 'Valor total de bônus resgatáveis',
    totalNonRedeemableBonusAmountWon: 'Valor total do bônus não resgatável ganho',
    totalNetAmountWon: 'Valor líquido total ganho',
    totalPlayerAmountWon: 'Valor total ganho pelo jogador',
    totalNonRedeemableBonusAmountWagered: 'Valor total do bônus não resgatável apostado',
    totalAmountLicenseeRake: 'Total de licenças',
    totalAmountJackpotRake: 'Comissão total do jackpot',
    monthlyGGR: 'GGR mensal',
    licenseName: 'Nome da licença',
    GGR: 'GGR',
    greekPublicParticipation: 'Participação pública grega',
    resourceEEEP: 'Recurso EEEP',
    hGCBetEventID: 'ID do evento de aposta HGC',
    betEventType: 'Tipo de evento de aposta',
    mainBetEventID: 'ID do evento da aposta principal',
    betEventCreationDate: 'Data de criação do evento de aposta',
    betEventResultDate: 'Data do resultado do evento de aposta',
    betEventCancellation: 'Cancelamento de evento de aposta',
    betEventCancellationDate: 'Data de cancelamento do evento de aposta',
    eventName: 'Nome do evento',
    eventType: 'Tipo de evento',
    betEvents: 'Eventos de apostas',
    betEventCategoryB: 'Categoria de evento de aposta B',
    betEventCategoryC: 'Categoria de evento de aposta C',
    betEventCategoryD: 'Categoria de evento de aposta D',
    bonusSchemas: 'Esquemas de bônus',
    bonusStartDate: 'Data de início do bônus',
    bonusEndDate: 'Data de término do bônus',
    givenNumberOfBonus: 'Número dado de bônus',
    givenBonusAmount: 'Valor do bônus fornecido',
    usedNumberOfBonus: 'Número de bônus usado',
    usedBonusAmount: 'Valor do bônus usado',
    bonusCategoryA: 'Categoria de bônus A',
    bonusCategoryB: 'Categoria de bônus B',
    wagerMultiplier: 'Multiplicador de aposta',
    amountWageredIndicator: 'Indicador de valor apostado',
    otherWageringRequirements: 'Outros requisitos de apostas',
    onlineAccounts: 'Contas online',
    accountType: 'Tipo de conta',
    accountStatusDate: 'Data do status da conta',
    accountStatusReason: 'Motivo do status da conta',
    surname: 'Sobrenome',
    idNumber: 'Número de identificação',
    passportNumber: 'Número do passaporte',
    vatNumber: 'Número de IVA',
    amkaNumber: 'Número Amka',
    addressCountry: 'País do enedreço',
    postCode: 'Código postal',
    emailAddress: 'Endereço de email',
    kycDate: 'Data KYC',
    playersBetting: 'Apostas do jogador',
    eventId: 'ID do evento',
    betSettledPeriod: 'Período de liquidação de apostas',
    betTypeB: 'Tipo de aposta B',
    betStatus: 'Status da aposta',
    betIp: 'IP da aposta',
    playerRisk: 'Risco do jogador',
    betIdOdds: 'Odds por ID de aposta',
    betEventId: 'ID do evento de aposta',
    betEventName: 'Nome do evento de aposta',
    betEventOdds: 'Odds do evento de aposta',
    betPlacedDate: 'Data da aposta',
    betSettlementDate: 'Data de liquidação de aposta',
    netAmountWon: 'Valor líquido ganho',
    withholdingTax2_5: 'Imposto retido na fonte 2,5%',
    withholdingTax5: 'Imposto retido na fonte 5%',
    withholdingTax7_5: 'Imposto retido na fonte 7,5%',
    realMoneyWagers: 'Apostas com dinheiro real',
    nonRedeemableBonuses: 'Bônus não resgatáveis',
    realMoneyWinnings: 'Ganhos em dinheiro real',
    winningsFromNonRedeemableBonuses: 'Ganhos de bônus não resgatáveis',
    bettingPerformance: 'Desempenho de apostas',
    domainName: 'Nome de domínio',
    betType: 'Tipo de aposta',
    totalNumberWagers: 'Número total de apostas',
    totalNumberWagersSettled: 'Número total de apostas liquidadas',
    totalNonRedeemableBonusAmountWageredSettled: 'Valor total do bônus não resgatável apostado e liquidado',
    recordType: 'Tipo de registro',
    gamePerformanceDaily: 'Desempenho diário do jogo',
    sharedLiquidityIndicator: 'Indicador de liquidez compartilhada',
    totalNumberGameSessions: 'Número total de sessões de jogo',
    totalNumberPokerCashGamesHands: 'Número total de mãos em jogos de Poker Cash',
    totalNumberTaxationSessions: 'Número total de sessões de tributação',
    totalNumberJackpots: 'Total de Jackpots',
    totalNumberIncompleteGameSessions: 'Número total de sessões de jogo incompletas',
    bettingAndSelfProtection: 'Apostas e autoproteção',
    jackpotSettings: 'Configurações de jackpot',
    jackpotProviderID: 'ID do provedor do jackpot',
    profitDistributionLevelCount: 'Contagem do nível de distribuição de lucros',
    increaseRate: 'Taxa de aumento',
    startUpAmount: 'Valor inicial',
    amountJackpotLimitFloor: 'Valor mínimo do limite do jackpot',
    amountJackpotLimitCeiling: 'Valor máximo do limite do jackpot',
    timeJackpotLimitCeiling: 'Limite máximo de tempo do jackpot',
    totalJackpotAmount: 'Valor total do jackpot',
    paytableIDCount: 'Contagem do ID da tabela de pagamentos',
    paytableID: 'ID da tabela de pagamentos',
    jackpotEndDate: 'Data de término do jackpot',
    jackpotTransferedAmount: 'Valor transferido do jackpot',
    oldProfitDistributionLevelID: 'ID do nível antigo de distribuição de lucros',
    newJackpotID: 'Novo ID do Jackpot',
    newProfitDistributionLevelID: 'ID do novo nível de distribuição de lucros',
    jackpotTransferredDate: 'Data de transferência do jackpot',
    jackpotStartDate: 'Data de início do jackpot',
    totalExclusionCount: 'Contagem total de exclusões',
    taxAmountPercent: 'Valor do imposto ({{percent}}%)',
    totalBalances: 'Saldos totais',
    companyProfit: 'Lucro da empresa',
    balanceAvailable: 'Saldo disponível',
    nonRedeemableBonusAmountWagered: 'Valor do bônus não resgatável apostado',
    totalWithholdingTax: 'Total de imposto retido na fonte',
    nonRedeemableBonusAmountWon: 'Valor do bônus não resgatável ganho',
    minimumWagerAmount: 'Valor mínimo da aposta',
    withholdingTax15: 'Imposto retido na fonte 15%',
    withholdingTax20: 'Imposto retido na fonte 20%',
    addServer: 'Adicionar servidor',
    ggrTaxAmount15: 'Valor do imposto GGR (15%)',
    addChange: 'Adicionar alteração ',
    tournament: 'Torneio',
    stake: 'Aposta',
    mainEvent: 'Evento principal',
    total: 'Total',
  },
  zh: {
    changes: '改变',
    changeDate: '改变日期',
    changedBy: '更改者',
    gameRatio: '游戏比例',
    gameTypes: '游戏类型',
    totalCurrentAmount: '当前总金额',
    operatorIncome: '运营商收入',
    playerExclusion: '玩家排除',
    exclusionType: '排除类型',
    appliedBy: '应用方',
    total: '总的',
    totalFunds: '资金总额',
    operatorsIncome: '运营商收入',
    totalAmountReturned: '返回的总金额',
    totalAddedAmount: '总增加金额',
    totalEarnedAmount: '总收入金额',
    balanceAdjustment: '余额调整',
    playerFullName: '玩家的名和姓',
    balanceAdjustmentDate: '余额调整日期',
    fixedOddsTotalBetAmount: '固定赔率总投注额',
    fixedOddsTotalLostAmount: '固定赔率总赢利金额',
    fixedOddsBonusBetAmount: '固定赔率总奖金投注',
    casinoTotalBetAmount: '娱乐场游戏总投注额',
    casinoTotalWinAmount: '娱乐场游戏总获胜金额',
    casinoTotalLostAmount: '娱乐场游戏总损失金额',
    casinoBonusBetAmount: '娱乐场游戏总奖金投注',
    sessionEndReason: '专场结束的原因',
    unsettledFundsAmount: '未结算资金金额',
    fixedOddsTotalWinAmount: '赢钱总额的固定赔率',
    safeServer: '安全服务器',
    casinoGamesTotalBonusAmount: '娱乐场游戏的总奖金数额',
    fixedOddsTotalBonusAmount: '固定赔率总赢利金额',
    mirroringServer: '镜像服务器',
    logDate: '日志日期',
    changeNotification: '更改通知',
    changeCategory: '更改类别',
    changeDescription: '更改说明',
    changeReason: '更改原因',
    previousVersion: '先前版本',
    currentVersion: '当前版本',
    change: '更改',
    inaccessibilityAreas: '无法访问区域',
    inaccessibilityFrom: '无法访问从',
    inaccessibilityTo: '无法访问至',
    inaccessibilityReason: '无法访问原因',
    reconnectionFailedAttempts: '重新连接失败尝试',
    serverName: '服务器名称',
    inaccessibilityDate: '无法访问日期',
    inaccessibilityServer: '无法访问朝务器',
    largeTransactionsInfo: '系统对该报告使用默认转换，如果您想更改转换，可以从品牌设置→转换设置→其他中进行更改。',
    balanceAdjustmentCount: '余额调整计数',
    selfExclusionCount: '自我排除计数',
    accountClosedCount: '账户关闭计数',
    operatorInterventionCount: '操作员介入次数',
    unusualEventsCount: '其他巨大/异常事件计数',
    jackpotWinRatio: '大奖中奖率',
    jackpotConfiguration: '大奖配置',
    jackpotName: '大奖名',
    gamePaylistId: '游戏付费表ID',
    jackpotPrizeDate: '大奖日期',
    maximumJackpotLevel: '最高大奖级别',
    jackpotAmount: '大奖金额',
    processingUserID: '处理用户ID',
    processingUserName: '处理用户名',
    confirmingUserID: '确认用户ID',
    confirmingUserName: '确认用户坝',
    progressiveJackpotName: '累积大奖名',
    setupParameters: '设置参数',
    existingGamesPaylist: '现有游戏付费表',
    totalBetsAmount: '投注总额',
    totalContributionsWinAmount: '总贡献获胜金额',
    nonContributionFinance: '非贡献财务',
    jackpotPrizeCurrentAmount: '大奖奖励当前金额',
    jackpotContributionCurrentAmount: '大奖贡献当前金额',
    terminationDate: '终止日期',
    maximumAwardedAmount: '最高奖励金额',
    exceedingLimitAmount: '超出限制金额',
    promotionalItems: '促销品',
    promotionId: '促销ID',
    promotionType: '促销类型',
    totalBalanceAllocated: '分配余额共计',
    totalAmountPrizes: '总金额 - 奖励',
    totalAmountUsed: '已用总额',
    totalAdjustmentAmount: '调整总额',
    finalBalance: '最终余额',
    softwareChanges: '软件变更',
    taxationDaily: '税务日报',
    taxationMonthly: '税务月报',
    betWin: '投注赢',
    quarterDetails: '季度详情',
    statisticalReportQuarter: '统计报告Q{{quarter}} {{year}}',
    bettingSelfProtectionReportInfo: '所杝供的报告仅基于哝牌的时区，此页面中的任何时区坘化都丝会影哝报告',
    serverInaccessibility: '服务器无法访问 (重要活动)',
    largeTransactions: '大额交易 (重要活动)',
    restrictions: '限制 (重要活动)',
    totalAmountExpired: '过期总金额',
    report: '报告',
    exclusions: '不适用情况',
    selectCriteriaToGenerateOrExportReport: '选择生成或导出报告的标准',
    run: '运行',
    exclusionId: '排除ID',
    exclusionDurationCategory: '排除期限类别',
    exclusionChannel: '排除通道',
    exclusionRequestDate: '排除请求日期',
    expectedExclusionDuration: '预期排除期限',
    exclusionStartDate: '排除开始日期',
    endExclusionRequestDate: '排除请求结束日期',
    exclusionEndDate: '排除结束日期',
    exclusionReason: '排除原因',
    reportCreationDate: '报告创建日期',
    reportUpdateDate: '报告更新日期',
    resetFilters: '重置筛选器',
    licenseeLegalName: '许可法定名称',
    licenseType: '许可类型',
    gameCategoryA: '游戏类别A',
    betCategoryB: '投注类别B',
    totalAmountWagered: '工资总额',
    totalAmountWageredSettled: '已结算的工资总额',
    totalNumberPlayers: '玩家总数',
    totalNumberPlayersSettled: '已结算玩家总数',
    totalAmountWon: '总获奖金额',
    totalAmountWonJackpots: '赢得的大奖总额',
    totalNumberPlayersWon: '获胜选手总数',
    totalAmountWithholdingTax: '预扣税款总额',
    contribution345: '贡献345',
    contributionHGC05: '贡献HGC05',
    monthlyEconomic: '月度经济',
    month: '月',
    jackpotWinnings: '大奖赢利',
    jackpotID: '大奖ID',
    jackpotType: '大奖类型',
    jackpotStatus: '大奖状态',
    profitDistributionLevelID: '利润分配级别ID',
    jackpotWonDate: '大奖赢得日期',
    totalJackpotWonAmount: '大奖赢得总额',
    totalJackpotRake: '总大奖佣金',
    currency: '货币',
    ptPGameSessionID: 'Pt PGame会话ID',
    pokerTournamentID: '扑克锦标赛ID',
    jackpotPlayerAmount: '大奖玩家金额',
    winningsCategory: '赢利类别',
    totalNumberCoupons: '优惠券总数',
    playSession: '游戏环节',
    loginSessionStartDate: '登录会话开始日期',
    loginSessionEndDate: '登录会话结束日期',
    loginSessionEndReason: '登录会话原因',
    channelIndicator: '通道指示器',
    roamingIndicator: '漫游指示器',
    beginningBalance: '期初余额',
    endingBalance: '期末余额',
    reportDateFrom: '报告日期自',
    reportDateTo: '报告日期至',
    monthlyEconomicPlayerTaxes: '每月经济玩家税',
    totalNumberSessions: '总场次',
    monthlyEconomicBetting1: '每月经济博彩1',
    betEventCategoryA: '投注赛事类别A',
    limitCategory: '限制类别',
    limitCreationDate: '限制创建日期',
    limitChangeDate: '限制变更日期',
    limitStartDate: '限制开始日期',
    newLimitDuration: '新的限制持续时间（小时）',
    newLimitAmount: '新的限额',
    oldLimitDuration: '旧限制持续时间（小时）',
    oldLimitAmount: '旧限额',
    limitInitiator: '限制启动',
    logInSessionId: '登录会话ID',
    gameSessions: '游戏会话',
    manufacturerLN: '制造商LN',
    totalRedeemableBonusAmount: '可兑现奖金总额',
    totalNonRedeemableBonusAmountWon: '赢得的不可兑换奖金总额',
    totalNetAmountWon: '总净赢金额',
    totalPlayerAmountWon: '玩家赢得的总金额',
    totalNonRedeemableBonusAmountWagered: '不可兑换奖金总额投注',
    totalAmountLicenseeRake: '总许可佣金',
    totalAmountJackpotRake: '总大奖佣金',
    monthlyGGR: '每月GGR',
    licenseName: '许可名称',
    GGR: 'GGR',
    greekPublicParticipation: '希腊公众参与',
    resourceEEEP: '资源EEEP',
    hGCBetEventID: 'HGC博彩活动ID',
    betEventType: '投注活动类型',
    mainBetEventID: '主要投注活动ID',
    betEventCreationDate: '投注活动创建日期',
    betEventResultDate: '投注活动结果日期',
    betEventCancellation: '投注活动取消',
    betEventCancellationDate: '投注活动取消日期',
    eventName: '活动名称',
    eventType: '活动类型',
    betEvents: '投注活动',
    betEventCategoryB: '投注活动类别B',
    betEventCategoryC: '投注活动类别C',
    betEventCategoryD: '投注活动类别D',
    bonusSchemas: '奖金方案',
    bonusStartDate: '奖金开始日期',
    bonusEndDate: '奖金结束日期',
    givenNumberOfBonus: '给定奖金数',
    givenBonusAmount: '给定奖金额',
    usedNumberOfBonus: '已使用的奖金数',
    usedBonusAmount: '已用奖金数额',
    bonusCategoryA: '奖金类别A',
    bonusCategoryB: '奖金类别B',
    wagerMultiplier: '投注倍数',
    amountWageredIndicator: '投注金额指标',
    otherWageringRequirements: '其他投注要求',
    onlineAccounts: '在线账户',
    accountType: '账户类型',
    accountStatusDate: '帐户状态日期',
    accountStatusReason: '帐户状态原因',
    surname: '姓',
    idNumber: 'ID号码',
    passportNumber: '护照号',
    vatNumber: '增值税识别号',
    amkaNumber: 'Amka号码',
    addressCountry: '住址 国家',
    postCode: '邮编',
    emailAddress: '电子邮件地址',
    kycDate: 'Kyc日期',
    playersBetting: '玩家投注',
    eventId: '活动ID',
    betSettledPeriod: '投注结算期',
    betTypeB: '投注类型B',
    betStatus: '投注状态',
    betIp: '投注IP',
    playerRisk: '玩家风险',
    betIdOdds: '投注ID赔率',
    betEventId: '投注活动ID',
    betEventName: '投注活动名称',
    betEventOdds: '投注赛事赔率',
    betPlacedDate: '投注日期',
    betSettlementDate: '投注结算日期',
    netAmountWon: '净赢金额',
    withholdingTax2_5: '预扣税2.5%',
    withholdingTax5: '预扣税5%',
    withholdingTax7_5: '预扣税7.5%',
    realMoneyWagers: '真钱投注',
    nonRedeemableBonuses: '不可兑换奖金',
    realMoneyWinnings: '真钱赢取',
    winningsFromNonRedeemableBonuses: '不可兑换奖金的赢利',
    bettingPerformance: '投注表现',
    domainName: '域名',
    betType: '投注类型',
    totalNumberWagers: '投注总数',
    totalNumberWagersSettled: '已结算投注总数',
    totalNonRedeemableBonusAmountWageredSettled: '不可兑换奖金总额 已下注 已结算',
    recordType: '记录类型',
    gamePerformanceDaily: '游戏表现日报',
    sharedLiquidityIndicator: '共享流动性指标',
    totalNumberGameSessions: '游戏会话总数',
    totalNumberPokerCashGamesHands: '扑克现金游戏手牌总数',
    totalNumberTaxationSessions: '税务会议总数',
    totalNumberJackpots: '大奖总数',
    totalNumberIncompleteGameSessions: '未完成游戏环节总数',
    bettingAndSelfProtection: '投注与自我保护',
    jackpotSettings: '大奖设置',
    jackpotProviderID: '大奖提供商ID',
    profitDistributionLevelCount: '利润分配级别计数',
    increaseRate: '增长率',
    startUpAmount: '启动数额',
    amountJackpotLimitFloor: '奖金限额底线',
    amountJackpotLimitCeiling: '数额大奖上限',
    timeJackpotLimitCeiling: '时间大奖上限',
    totalJackpotAmount: '总大奖数额',
    paytableIDCount: '支付表ID数量',
    paytableID: '支付表ID',
    jackpotEndDate: '大奖结束时间',
    jackpotTransferedAmount: '大奖转账额',
    oldProfitDistributionLevelID: '旧的利润分配级别ID',
    newJackpotID: '新大奖ID',
    newProfitDistributionLevelID: '新的利润分配级别ID',
    jackpotTransferredDate: '大奖转移日期',
    jackpotStartDate: '大奖开始日期',
    totalExclusionCount: '总排除数',
    taxAmountPercent: '税额 ({{percent}}%)',
    totalBalances: '总余额',
    companyProfit: '公司利润',
    balanceAvailable: '可用余额',
    nonRedeemableBonusAmountWagered: '不可兑换的奖金投注额',
    totalWithholdingTax: '预扣税总额',
    nonRedeemableBonusAmountWon: '不可兑换奖金金额',
    minimumWagerAmount: '最低投注金额',
    withholdingTax15: '预扣税15%',
    withholdingTax20: '预扣税20%',
    addServer: '添加服务器',
    ggrTaxAmount15: 'GGR税额 (15%)',
    addChange: '新增变更',
    tournament: '锦标赛',
    stake: '投注额',
    mainEvent: '主赛事',
  },
  ro: {
    changeDate: 'Data modificării',
    changedBy: 'Modificat de ',
    changes: 'Modificări',
    gameRatio: 'Raport de joc',
    gameTypes: 'Tipul jocului',
    totalCurrentAmount: 'Valoarea totală curentă',
    operatorIncome: 'Veniturile operatorului',
    playerExclusion: 'Excluderea jucătorilor',
    exclusionType: 'Tipul de excludere',
    appliedBy: 'Aplicat de către',
    totalFunds: 'Fonduri totale',
    operatorsIncome: 'Veniturile operatorilor',
    totalAmountReturned: 'Suma totală returnată',
    totalAddedAmount: 'Suma totală adăugată',
    totalEarnedAmount: 'Suma totală câștigată',
    balanceAdjustment: 'Ajustarea soldului',
    playerFullName: 'Numele și prenumele jucătorului',
    balanceAdjustmentDate: 'Data ajustării soldului',
    fixedOddsTotalBetAmount: 'Suma totală de pariu în cote fixe',
    fixedOddsTotalWinAmount: 'Suma totală de câștig în cote fixe',
    fixedOddsTotalLostAmount: 'Suma totală de pierdere în cote fixe',
    fixedOddsBonusBetAmount: 'Suma totală de bonus în cote fixe',
    casinoTotalBetAmount: 'Suma totală a pariului la jocuri de Casino',
    casinoTotalWinAmount: 'Suma totală de câștig la jocurile de Casino',
    casinoTotalLostAmount: 'Suma totală pierdută la jocuri de casino',
    casinoBonusBetAmount: 'Pariul total de Bonus la jocurile de casino',
    sessionEndReason: 'Motivul încheierii sesiunii',
    unsettledFundsAmount: 'Suma fondurilor nedecontate ',
    safeServer: 'Server de siguranță',
    casinoGamesTotalBonusAmount: 'Suma totală a Bonusului la jocuri de casino',
    fixedOddsTotalBonusAmount: 'Suma totală a Bonusului în cotă fixă',
    mirroringServer: 'Serverul de oglindire',
    logDate: 'Data înregistrării',
    largeTransactions: 'Tranzacții mari (Evenimente Semnificative)',
    changeNotification: 'Modificare notificare',
    changeCategory: 'Modificare categorie',
    changeDescription: 'Modificare descriere',
    changeReason: 'Modificare motiv',
    previousVersion: 'Versiunea anterioară',
    currentVersion: 'Versiunea actuală',
    change: 'Modificare',
    inaccessibilityAreas: 'Zone de inaccesibilitate',
    inaccessibilityFrom: 'Inaccesibilitate de la',
    inaccessibilityTo: 'Inaccesibilitate la',
    inaccessibilityReason: 'Motiv inaccesibilitate',
    reconnectionFailedAttempts: 'Încercări eșuate de reconectare',
    serverName: 'Nume server',
    inaccessibilityDate: 'Dată inaccesibilitate',
    inaccessibilityServer: 'Server inaccesibilitate',
    largeTransactionsInfo: 'Sistemul utilizează conversia implicită pentru acest raport. Dacă dorești să modifici conversia, o poți face din „Setări marcă”→„Setări conversie”→„Altele”',
    balanceAdjustmentCount: 'Număr de ajustări ale soldului',
    selfExclusionCount: 'Număr de autoexcluderi',
    accountClosedCount: 'Număr de conturi închise',
    operatorInterventionCount: 'Număr intervenții operator',
    unusualEventsCount: 'Număr alte evenimente importante/neobișnuite',
    jackpotWinRatio: 'Raport câștig Jackpot',
    jackpotConfiguration: 'Configurație Jackpot',
    jackpotName: 'Nume Jackpot',
    gamePaylistId: 'ID listă de plată joc',
    jackpotPrizeDate: 'Dată premiu Jackpot',
    maximumJackpotLevel: 'Nivel Jackpot maxim',
    jackpotAmount: 'Valoare Jackpot',
    processingUserID: 'ID utilizator în curs de procesare',
    processingUserName: 'Nume de utilizator în curs de procesare',
    confirmingUserID: 'ID utilizator în curs de confirmare',
    confirmingUserName: 'Nume de utilizator în curs de confirmare',
    progressiveJackpotName: 'Nume Jackpot progresiv',
    setupParameters: 'Parametrii de setare',
    existingGamesPaylist: 'Listă de plată jocuri existente',
    totalBetsAmount: 'Valoare totală pariuri',
    totalContributionsWinAmount: 'Contribuții totale la valoarea câștigului',
    nonContributionFinance: 'Finanțare fără contribuție',
    jackpotPrizeCurrentAmount: 'Valoare actuală premiu Jackpot',
    jackpotContributionCurrentAmount: 'Valoare actuală contribuție Jackpot',
    terminationDate: 'Data încetării',
    maximumAwardedAmount: 'Valoare maximă acordată',
    exceedingLimitAmount: 'Valoarea limită depășită',
    promotionalItems: 'Articole promoționale',
    promotionId: 'ID promoție',
    promotionType: 'Tip promoție',
    totalBalanceAllocated: 'Sold total alocat',
    totalAmountPrizes: 'Valoare totală - Premii',
    totalAmountUsed: 'Valoare totală utilizată',
    totalAdjustmentAmount: 'Valoare totală ajustare',
    finalBalance: 'Sold final',
    softwareChanges: 'Modificări de software',
    taxationDaily: 'Impozitare zilnică',
    taxationMonthly: 'Impozitare lunară',
    betWin: 'Câștig pariu',
    quarterDetails: 'Detalii trimestriale',
    statisticalReportQuarter: 'Raport statistic Q{{trimestru}} {{an}}',
    bettingSelfProtectionReportInfo: 'Raportul furnizat utilizează doar fusul orar al mărcii. Orice modificare a fusului orar pe această pagină nu va afecta raportul',
    totalAmountExpired: 'Suma totală expirată',
    report: 'Raportează',
    exclusions: 'Excluderi',
    selectCriteriaToGenerateOrExportReport: 'Selectați criteriile pentru a genera sau exporta raportul',
    run: 'Run',
    exclusionId: 'ID excludere',
    exclusionDurationCategory: 'Categoria duratei de excludere',
    exclusionChannel: 'Canal de excludere',
    exclusionRequestDate: 'Data solicitării de excludere',
    expectedExclusionDuration: 'Durata preconizată a excluderii',
    exclusionStartDate: 'Data de început a excluderii',
    endExclusionRequestDate: 'Data finală a solicitării de excludere',
    exclusionEndDate: 'Data de încheiere a excluderii',
    exclusionReason: 'Motivul excluderii',
    reportCreationDate: 'Data creării raportului',
    reportUpdateDate: 'Data actualizării raportului',
    resetFilters: 'Resetare filtre',
    licenseeLegalName: 'Denumirea juridică a beneficiarului licenței',
    licenseType: 'Tip licență',
    gameCategoryA: 'Categoria A de jocuri',
    betCategoryB: 'Categoria B de pariuri',
    totalAmountWagered: 'Valoare totală rulată',
    totalAmountWageredSettled: 'Valoare totală rulată decisă',
    totalNumberPlayers: 'Număr total de jucători',
    totalNumberPlayersSettled: 'Număr total de jucători cu pariuri decise',
    totalAmountWon: 'Valoare totală a câștigului',
    totalAmountWonJackpots: 'Valoare totală a jackpoturilor câștigate',
    totalNumberPlayersWon: 'Număr total de jucători care au câștigat',
    totalAmountWithholdingTax: 'Valoare totală a impozitului reținut la sursă',
    contribution345: 'Contribution345',
    contributionHGC05: 'ContributionHGC05',
    monthlyEconomic: 'Economic lunar',
    month: 'Lună',
    jackpotWinnings: 'Câștiguri jackpot',
    jackpotID: 'ID jackpot',
    jackpotType: 'Tip de jackpot',
    jackpotStatus: 'Starea jackpotului',
    profitDistributionLevelID: 'ID nivel de distribuție a profitului',
    jackpotWonDate: 'Data câștigării jackpotului',
    totalJackpotWonAmount: 'Valoarea totală a jackpotului câștigat',
    totalJackpotRake: 'Taxă totală pe jackpot',
    currency: 'Monedă',
    ptPGameSessionID: 'ID sesiune de joc între jucători reali',
    pokerTournamentID: 'ID turneu de poker',
    jackpotPlayerAmount: 'Număr de jucători câștigători ai jackpotului',
    winningsCategory: 'Categorie de câștiguri',
    totalNumberCoupons: 'Număr total de cupoane',
    playSession: 'Sesiune de joc',
    loginSessionStartDate: 'Data de început a sesiunii de conectare',
    loginSessionEndDate: 'Data de încheiere a sesiunii de conectare',
    loginSessionEndReason: 'Motivul sesiunii de conectare',
    channelIndicator: 'Indicator canal',
    roamingIndicator: 'Indicator de roaming',
    beginningBalance: 'Sold inițial',
    endingBalance: 'Sold final',
    reportDateFrom: 'Dată raport de la',
    reportDateTo: 'Dată raport până la',
    monthlyEconomicPlayerTaxes: 'Taxe jucător la pariuri economice lunare',
    totalNumberSessions: 'Număr total de sesiuni',
    monthlyEconomicBetting1: 'Pariuri economice lunare 1',
    betEventCategoryA: 'Categoria A de evenimente de pariuri',
    limitCategory: 'Categorie de limită',
    limitCreationDate: 'Data creării limitei',
    limitChangeDate: 'Data modificării limitei',
    limitStartDate: 'Data de început a limitei',
    newLimitDuration: 'Durată limită nouă (ore)',
    newLimitAmount: 'Valoare limită nouă',
    oldLimitDuration: 'Durată limită veche (ore)',
    oldLimitAmount: 'Valoare limită veche',
    limitInitiator: 'Inițiatorul limitei',
    logInSessionId: 'ID sesiune de conectare',
    gameSessions: 'Sesiuni de joc',
    manufacturerLN: 'NL Producător',
    totalRedeemableBonusAmount: 'Valoare totală a bonusurilor răscumpărabile',
    totalNonRedeemableBonusAmountWon: 'Valoare câștigată totală a bonusurilor nerăscumpărabile',
    totalNetAmountWon: 'Sumă totală netă câștigată',
    totalPlayerAmountWon: 'Sumă totală câștigată de jucător',
    totalNonRedeemableBonusAmountWagered: 'Valoare rulată totală a bonusurilor nerăscumpărabile',
    totalAmountLicenseeRake: 'Taxă totală beneficiar licență',
    totalAmountJackpotRake: 'Taxă totală pe jackpot',
    monthlyGGR: 'VBJ lunar',
    licenseName: 'Nume licență',
    GGR: 'GGR',
    greekPublicParticipation: 'Participarea publicului grec',
    resourceEEEP: 'Resurse EEEP',
    hGCBetEventID: 'ID eveniment de pariuri HGC',
    betEventType: 'Tipul evenimentului de pariuri',
    mainBetEventID: 'ID eveniment de pariuri principal',
    betEventCreationDate: 'Data creării evenimentului de pariuri',
    betEventResultDate: 'Data rezultatului evenimentului de pariuri',
    betEventCancellation: 'Anulare eveniment de pariuri',
    betEventCancellationDate: 'Data anulării evenimentului de pariuri',
    eventName: 'Numele evenimentului',
    eventType: 'Tipul evenimentului',
    betEvents: 'Evenimente de pariuri',
    betEventCategoryB: 'Categoria B de evenimente de pariuri',
    betEventCategoryC: 'Categoria C de evenimente de pariuri',
    betEventCategoryD: 'Categoria D de evenimente de pariuri',
    bonusSchemas: 'Scheme de bonusuri',
    bonusStartDate: 'Data de început a bonusului',
    bonusEndDate: 'Data de încheiere a bonusului',
    givenNumberOfBonus: 'Numărul de bonusuri acordate',
    givenBonusAmount: 'Valoarea bonusului acordat',
    usedNumberOfBonus: 'Număr utilizat de bonusuri',
    usedBonusAmount: 'Valoare utilizată a bonusului',
    bonusCategoryA: 'Categoria A de bonusuri',
    bonusCategoryB: 'Categoria B de bonusuri',
    wagerMultiplier: 'Multiplicator rulaj',
    amountWageredIndicator: 'Indicator sumă pariată',
    otherWageringRequirements: 'Cerințe privind rularea',
    onlineAccounts: 'Conturi online',
    accountType: 'Tip cont',
    accountStatusDate: 'Data stării contului',
    accountStatusReason: 'Motivul stării contului',
    surname: 'Prenume',
    idNumber: 'Număr ID',
    passportNumber: 'Număr pașaport',
    vatNumber: 'Număr de TVA',
    amkaNumber: 'Număr Amka',
    addressCountry: 'Țară adresă',
    postCode: 'Cod poștal',
    emailAddress: 'Adresă de e-mail',
    kycDate: 'Data KYC',
    playersBetting: 'Pariurile jucătorului',
    eventId: 'ID eveniment',
    betSettledPeriod: 'Perioada deciderii pariului',
    betTypeB: 'Tipul B de pariuri',
    betStatus: 'Stare pariu',
    betIp: 'IP pariu',
    playerRisk: 'Riscul jucătorului',
    betIdOdds: 'Cotele ID-ului de pariu',
    betEventId: 'ID eveniment de pariuri',
    betEventName: 'Numele evenimentului de pariuri',
    betEventOdds: 'Cotele evenimentului de pariuri',
    betPlacedDate: 'Data plasării pariului',
    betSettlementDate: 'Data deciderii pariului',
    netAmountWon: 'Sumă netă câștigată',
    withholdingTax2_5: 'Impozit cu reținere la sursă de 2,5%',
    withholdingTax5: 'Impozit cu reținere la sursă de 5%',
    withholdingTax7_5: 'Impozit cu reținere la sursă de 7,5%',
    realMoneyWagers: 'Rulaje bani reali',
    nonRedeemableBonuses: 'Bonusuri nerăscumpărabile',
    realMoneyWinnings: 'Câștiguri bani reali',
    winningsFromNonRedeemableBonuses: 'Câștiguri din bonusuri nerăscumpărabile',
    bettingPerformance: 'Performanță pariuri',
    domainName: 'Nume domeniu',
    betType: 'Tip pariu',
    totalNumberWagers: 'Număr total de rulaje',
    totalNumberWagersSettled: 'Număr total de rulaje decise',
    totalNonRedeemableBonusAmountWageredSettled: 'Valoare rulată totală a bonusurilor nerăscumpărabile decise',
    recordType: 'Tip record',
    gamePerformanceDaily: 'Performanță zilnică joc',
    sharedLiquidityIndicator: 'Indicatori de lichiditate partajată',
    totalNumberGameSessions: 'Număr total de sesiuni de joc',
    totalNumberPokerCashGamesHands: 'Număr total de mâini cu bani reali la poker',
    totalNumberTaxationSessions: 'Număr total de sesiuni de impozitare',
    totalNumberJackpots: 'Număr total de jackpoturi',
    totalNumberIncompleteGameSessions: 'Număr total de sesiuni de joc nefinalizate',
    bettingAndSelfProtection: 'Pariuri și autoprotecție',
    jackpotSettings: 'Setări jackpot',
    jackpotProviderID: 'ID furnizor jackpot',
    profitDistributionLevelCount: 'Număr de niveluri de distribuție a profitului',
    increaseRate: 'Rata de creștere',
    startUpAmount: 'Valoare de pornire',
    amountJackpotLimitFloor: 'Limita inferioară a valorii jackpotului',
    amountJackpotLimitCeiling: 'Limita superioară a valorii jackpotului',
    timeJackpotLimitCeiling: 'Limita superioară a jackpotului',
    totalJackpotAmount: 'Valoare totală a jackpotului',
    paytableIDCount: 'Cont ID tabel de plăți',
    paytableID: 'ID tabel de plăți',
    jackpotEndDate: 'Data de încheiere a jackpotului',
    jackpotTransferedAmount: 'Valoare transferată din jackpot',
    oldProfitDistributionLevelID: 'ID nivel de distribuție a profitului vechi',
    newJackpotID: 'ID jackpot nou',
    newProfitDistributionLevelID: 'ID nivel de distribuție a profitului nou',
    jackpotTransferredDate: 'Data transferului jackpotului',
    jackpotStartDate: 'Data de început a jackpotului',
    totalExclusionCount: 'Număr total de excluderi',
    taxAmountPercent: 'Valoare impozit ({{procent}}%)',
    totalBalances: 'Total solduri',
    companyProfit: 'Profitul companiei',
    balanceAvailable: 'Sold disponibil',
    nonRedeemableBonusAmountWagered: 'Bonus nerăscumpărabil pentru suma pariată',
    totalWithholdingTax: 'Total impozit cu reținere la sursă',
    nonRedeemableBonusAmountWon: 'Bonus nerăscumpărabil pentru suma câștigată',
    minimumWagerAmount: 'Valoare minimă de rulare',
    withholdingTax15: 'Impozit cu reținere la sursă de 15%',
    withholdingTax20: 'Impozit cu reținere la sursă de 20%',
    addServer: 'Adăugare server',
    serverInaccessibility: 'Inaccesibilitatea serverului (evenimente semnificative)',
    restrictions: 'Restricții (evenimente semnificative)',
    ggrTaxAmount15: 'Valoarea impozitului pe VBJ (15%)',
    addChange: 'Adăugare modificare',
    tournament: 'Turneu',
    stake: 'Miză',
    mainEvent: 'Eveniment principal',
    total: 'Total',
  },
  bg: {},
  el: {
    changes: 'Αλλαγές',
    changeDate: 'Ημερομηνία αλλαγής',
    changedBy: 'Η αλλαγή έγινε από',
    gameRatio: 'Αναλογία διαστάσεων παιχνιδιού',
    gameTypes: 'Τύποι παιχνιδιού',
    totalCurrentAmount: 'Συνολικό τρέχον ποσό',
    operatorIncome: 'Έσοδα χειριστή',
    playerExclusion: 'Αποκλεισμός παίκτη',
    exclusionType: 'Τύπος αποκλεισμού',
    appliedBy: 'Εφαρμόστηκε από',
    totalFunds: 'Συνολικά χρήματα',
    operatorsIncome: 'Έσοδα χειριστών',
    totalAmountReturned: 'Συνολικό ποσό που επιστράφηκε',
    totalAddedAmount: 'Συνολικό ποσό που προστέθηκε',
    totalEarnedAmount: 'Συνολικό ποσό που κερδήθηκε',
    balanceAdjustment: 'Προσαρμογή υπολοίπου',
    playerFullName: "'Ονομα και Επώνυμο παίκτη",
    balanceAdjustmentDate: 'Ημερομηνία προσαρμογής υπολοίπου',
    fixedOddsTotalBetAmount: 'Συνολικό ποσό στοιχήματος με σταθερές αποδόσεις',
    fixedOddsTotalWinAmount: 'Συνολικό ποσό κέρδους με σταθερές αποδόσεις',
    fixedOddsTotalLostAmount: 'Συνολικό ποσό απώλειας με σταθερές αποδόσεις',
    fixedOddsBonusBetAmount: 'Συνολικό μπόνους στοίχημα με σταθερές αποδόσεις',
    casinoTotalBetAmount: 'Συνολικό ποσό στοιχήματος σε παιχνίδια καζίνο',
    casinoTotalWinAmount: 'Συνολικό ποσό κέρδους σε παιχνίδια καζίνο',
    casinoTotalLostAmount: 'Συνολικό ποσό απώλειας σε παιχνίδια καζίνο',
    casinoBonusBetAmount: 'Συνολικό στοίχημα μπόνους σε παιχνίδια καζίνο',
    sessionEndReason: 'Αιτία λήξης συνεδρίας',
    unsettledFundsAmount: 'Ποσό μη διευθετημένων χρημάτων',
    safeServer: 'Ασφαλής διακομιστής',
    casinoGamesTotalBonusAmount: 'Συνολικό ποσό μπόνους σε παιχνίδια καζίνο',
    fixedOddsTotalBonusAmount: 'Συνολικό ποσό μπόνους με σταθερές αποδόσεις',
    mirroringServer: 'Διακομιστής-καθρέπτης',
    logDate: 'Ημερομηνία αρχείου καταγραφής',
    changeNotification: 'Ειδοποίηση αλλαγής',
    changeCategory: 'Κατηγορία αλλαγής',
    changeDescription: 'Περιγραφή αλλαγής',
    changeReason: 'Αιτία αλλαγής',
    previousVersion: 'Προηγούμενη έκδοση',
    currentVersion: 'Τρέχουσα έκδοση',
    change: 'Αλλαγή',
    inaccessibilityAreas: 'Περιοχές έλλειψης προσβασιμότητας',
    inaccessibilityFrom: 'Έλλειψη προσβασιμότητας από',
    inaccessibilityTo: 'Έλλειψη προσβασιμότητας έως',
    inaccessibilityReason: 'Αιτία έλλειψης προσβασιμότητας',
    reconnectionFailedAttempts: 'Αποτυχημένες προσπάθειες επανασύνδεσης',
    serverName: 'Όνομα διακομιστή',
    inaccessibilityDate: 'Ημερομηνία έλλειψης προσβασιμότητας',
    inaccessibilityServer: 'Διακομιστής έλλειψης προσβασιμότητας',
    largeTransactionsInfo:
      'Το σύστημα χρησιμοποιεί την προεπιλεγμένη μετατροπή για αυτή την αναφορά. Αν θέλετε να αλλάξετε τη μετατροπή, μπορείτε να το κάνετε από Ρυθμίσεις επωνυμίας -> Ρυθμίσεις μετατροπών -> Άλλα',
    balanceAdjustmentCount: 'Αριθμός προσαρμογών υπολοίπου',
    selfExclusionCount: 'Αριθμός αυτοαποκλεισμών',
    accountClosedCount: 'Αριθμός κλειστών λογαριασμών',
    operatorInterventionCount: 'Αριθμός παρεμβάσεων χειριστή',
    unusualEventsCount: 'Αριθμός άλλων σημαντικών/ασυνήθιστων γεγονότων',
    jackpotWinRatio: 'Αναλογία κέρδους τζάκποτ',
    jackpotConfiguration: 'Διαμόρφωση τζάκποτ',
    jackpotName: 'Όνομα τζάκποτ',
    gamePaylistId: 'Αναγνωριστικό λίστας πληρωμών παιχνιδιού',
    jackpotPrizeDate: 'Ημερομηνία επάθλου τζάκποτ',
    maximumJackpotLevel: 'Ανώτατο επίπεδο τζάκποτ',
    jackpotAmount: 'Ποσό τζάκποτ',
    processingUserID: 'Γίνεται επεξεργασία του αναγνωριστικού χρήστη',
    processingUserName: 'Γίνεται επεξεργασία του ονόματος χρήστη',
    confirmingUserID: 'Γίνεται επιβεβαίωση του αναγνωριστικού χρήστη',
    confirmingUserName: 'Γίνεται επιβεβαίωση του ονόματος χρήστη',
    progressiveJackpotName: 'Όνομα Προοδευτικού τζάκποτ',
    setupParameters: 'Παράμετροι ρύθμισης',
    existingGamesPaylist: 'Υφιστάμενη λίστα πληρωμών παιχνιδιών',
    totalBetsAmount: 'Συνολικό ποσό στοιχημάτων',
    totalContributionsWinAmount: 'Συνολικό ποσό κέρδους από συνεισφορές',
    nonContributionFinance: 'Οικονομικά χωρίς συνεισφορές',
    jackpotPrizeCurrentAmount: 'Τρέχον ποσό επάθλου τζάκποτ',
    jackpotContributionCurrentAmount: 'Τρέχον ποσό συνεισφοράς τζάκποτ',
    terminationDate: 'Ημερομηνία τερματισμού',
    maximumAwardedAmount: 'Μέγιστο ποσό που δόθηκε',
    exceedingLimitAmount: 'Υπερβαίνον ποσό ορίου',
    promotionalItems: 'Στοιχεία προωθητικών ενεργειών',
    promotionId: 'Αναγνωριστικό προωθητικής ενέργειας',
    promotionType: 'Τύπος προωθητικής ενέργειας',
    totalBalanceAllocated: 'Συνολικό υπόλοιπο που δόθηκε',
    totalAmountPrizes: 'Συνολικό ποσό - Έπαθλα',
    totalAmountUsed: 'Συνολικό ποσό που χρησιμοποιήθηκε',
    totalAdjustmentAmount: 'Συνολικό ποσό προσαρμογής',
    finalBalance: 'Τελικό υπόλοιπο',
    softwareChanges: 'Αλλαγές λογισμικού',
    serverInaccessibility: 'Έλλειψη προσβασιμότητας διακομιστή (Σημαντικά γεγονότα)',
    largeTransactions: 'Μεγάλες συναλλαγές (Σημαντικά γεγονότα)',
    restrictions: 'Περιορισμοί (Σημαντικά γεγονότα)',
    taxationDaily: 'Φορολόγηση ημερήσια',
    taxationMonthly: 'Φορολόγηση μηνιαία',
    betWin: 'Κέρδος στοιχήματος',
    quarterDetails: 'Στοιχεία τριμήνου',
    statisticalReportQuarter: 'Στατιστική έκθεση Τριμήνου {{quarter}} {{year}}',
    bettingSelfProtectionReportInfo: 'Η παρεχόμενη αναφορά βασίζεται μόνο στη ζώνη ώρας της επωνυμίας και τυχόν αλλαγές στη ζώνη ώρας σε αυτή τη σελίδα δεν θα επηρεάσουν την αναφορά',
    totalAmountExpired: 'Συνολικό ποσό που έληξε',
    report: 'Αναφορά',
    exclusions: 'Αποκλεισμοί',
    selectCriteriaToGenerateOrExportReport: 'Επιλέξτε κριτήρια για τη δημιουργία ή την εξαγωγή αναφοράς',
    run: 'Εκτέλεση',
    exclusionId: 'Αναγνωριστικό αποκλεισμού',
    exclusionDurationCategory: 'Κατηγορία διάρκειας αποκλεισμού',
    exclusionChannel: 'Κανάλι αποκλεισμού',
    exclusionRequestDate: 'Ημερομηνία αιτήματος αποκλεισμού',
    expectedExclusionDuration: 'Αναμενόμενη διάρκεια αποκλεισμού',
    exclusionStartDate: 'Ημερομηνία έναρξης αποκλεισμού',
    endExclusionRequestDate: 'Ημερομηνία λήξης αιτήματος αποκλεισμού',
    exclusionEndDate: 'Ημερομηνία λήξης αποκλεισμού',
    exclusionReason: 'Λόγος αποκλεισμού',
    reportCreationDate: 'Ημερομηνία δημιουργίας αναφοράς',
    reportUpdateDate: 'Ημερομηνία ενημέρωσης αναφοράς',
    resetFilters: 'Επαναφορά φίλτρων',
    licenseeLegalName: 'Πλήρες ονοματεπώνυμο κατόχου άδειας',
    licenseType: 'Τύπος άδειας',
    gameCategoryA: 'Κατηγορία παιχνιδιών Α',
    betCategoryB: 'Κατηγορία στοιχημάτων Β',
    totalAmountWagered: 'Συνολικό ποσό που στοιχηματίστηκε',
    totalAmountWageredSettled: 'Συνολικό ποσό που στοιχηματίστηκε και διευθετήθηκε',
    totalNumberPlayers: 'Συνολικός αριθμός παικτών',
    totalNumberPlayersSettled: 'Συνολικός αριθμός παικτών που διευθετήθηκε',
    totalAmountWon: 'Συνολικό ποσό που κερδήθηκε',
    totalAmountWonJackpots: 'Συνολικό ποσό που κερδήθηκε σε Τζακπότ',
    totalNumberPlayersWon: 'Συνολικός αριθμός παικτών που κέρδισαν',
    totalAmountWithholdingTax: 'Συνολικό ποσό φόρου που παρακρατήθηκε',
    contribution345: 'Συνεισφορά345',
    contributionHGC05: 'ΣυνεισφοράHGC05',
    monthlyEconomic: 'Μηνιαία οικονομικά',
    month: 'Μήνας',
    jackpotWinnings: 'Κέρδη τζακπότ',
    jackpotID: 'Αναγνωριστικό τζάκποτ',
    jackpotType: 'Τύπος τζάκποτ',
    jackpotStatus: 'Κατάσταση τζάκποτ',
    profitDistributionLevelID: 'Αναγνωριστικό επιπέδου διανομής κέρδους',
    jackpotWonDate: 'Ημερομηνία κέρδους τζάκποτ',
    totalJackpotWonAmount: 'Συνολικό ποσό τζακπότ που κερδήθηκε',
    totalJackpotRake: 'Συνολική προμήθεια τζάκποτ',
    currency: 'Νόμισμα',
    ptPGameSessionID: 'Αναγνωριστικό συνεδρίας παιχνιδιού Παίκτη με Παίκτη (PtP)',
    pokerTournamentID: 'Αναγνωριστικό τουρνουά πόκερ',
    jackpotPlayerAmount: 'Ποσό τζάκποτ παίκτη',
    winningsCategory: 'Κατηγορία κερδών',
    totalNumberCoupons: 'Συνολικός αριθμός κουπονιών',
    playSession: 'Συνεδρία παιχνιδιού',
    loginSessionStartDate: 'Ημερομηνία έναρξης συνεδρίας σύνδεσης',
    loginSessionEndDate: 'Ημερομηνία λήξης συνεδρίας σύνδεσης',
    loginSessionEndReason: 'Λόγος συνεδρίας σύνδεσης',
    channelIndicator: 'Δείκτης καναλιού',
    roamingIndicator: 'Δείκτης Roaming',
    beginningBalance: 'Αρχικό υπόλοιπο',
    endingBalance: 'Τελικό υπόλοιπο',
    reportDateFrom: 'Ημερομηνία αναφοράς από',
    reportDateTo: 'Ημερομηνία αναφοράς μέχρι',
    monthlyEconomicPlayerTaxes: 'Μηνιαία οικονομικά παίκτη - φόροι',
    totalNumberSessions: 'Συνολικός αριθμός συνεδριών',
    monthlyEconomicBetting1: 'Μηνιαία οικονομικά στοιχήματα 1',
    betEventCategoryA: 'Κατηγορία γεγονότος στοιχήματος Α',
    limitCategory: 'Κατηγορία ορίου',
    limitCreationDate: 'Ημερομηνία δημιουργίας ορίου',
    limitChangeDate: 'Ημερομηνία αλλαγής ορίου',
    limitStartDate: 'Ημερομηνία έναρξης ορίου',
    newLimitDuration: 'Διάρκεια νέου ορίου (ώρες)',
    newLimitAmount: 'Νέο ποσό ορίου',
    oldLimitDuration: 'Διάρκεια παλιού ορίου (ώρες)',
    oldLimitAmount: 'Παλιό ποσό ορίου',
    limitInitiator: 'Εκκινητής ορίου',
    logInSessionId: 'Αναγνωριστικό συνεδρίας σύνδεσης',
    gameSessions: 'Συνεδρίες παιχνιδιού',
    manufacturerLN: 'ΚατασκευαστήςLN',
    totalRedeemableBonusAmount: 'Συνολικό ποσό εξαργυρώσιμων μπόνους',
    totalNonRedeemableBonusAmountWon: 'Συνολικό ποσό μη εξαργυρώσιμων μπόνους που κερδήθηκε',
    totalNetAmountWon: 'Συνολικό καθαρό ποσό που κερδήθηκε',
    totalPlayerAmountWon: 'Συνολικό ποσό που κέρδισε ο παίκτης',
    totalNonRedeemableBonusAmountWagered: 'Συνολικό ποσό μη εξαργυρώσιμων μπόνους που στοιχηματίστηκε',
    totalAmountLicenseeRake: 'Συνολική προμήθεια κατόχου αδείας',
    totalAmountJackpotRake: 'Συνολική προμήθεια τζάκποτ',
    monthlyGGR: 'Μηνιαίο GGR',
    licenseName: 'Ονομασία άδειας',
    GGR: 'GGR',
    greekPublicParticipation: 'Συμμετοχή ελληνικού δημοσίου',
    resourceEEEP: 'Πόρος ΕΕΕΠ',
    hGCBetEventID: 'Αναγνωριστικό γεγονότος στοιχήματος ΕΕΕΠ',
    betEventType: 'Τύπος γεγονότος στοιχήματος',
    mainBetEventID: 'Αναγνωριστικό βασικού γεγονότος στοιχήματος',
    betEventCreationDate: 'Ημερομηνία δημιουργίας γεγονότος στοιχήματος',
    betEventResultDate: 'Ημερομηνία αποτελέσματος γεγονότος στοιχήματος',
    betEventCancellation: 'Ακύρωση γεγονότος στοιχήματος',
    betEventCancellationDate: 'Ημερομηνία ακύρωσης γεγονότος στοιχήματος',
    eventName: 'Όνομα γεγονότος',
    eventType: 'Τύπος γεγονότος',
    betEvents: 'Γεγονότα στοιχήματος',
    betEventCategoryB: 'Κατηγορία γεγονότος στοιχήματος Β',
    betEventCategoryC: 'Κατηγορία γεγονότος στοιχήματος Γ',
    betEventCategoryD: 'Κατηγορία γεγονότος στοιχήματος Δ',
    bonusSchemas: 'Σχέδια μπόνους',
    bonusStartDate: 'Ημερομηνία έναρξης μπόνους',
    bonusEndDate: 'Ημερομηνία λήξης μπόνους',
    givenNumberOfBonus: 'Συγκεκριμένος αριθμός μπόνους',
    givenBonusAmount: 'Συγκεκριμένο ποσό μπόνους',
    usedNumberOfBonus: 'Χρησιμοποιημένος αριθμός μπόνους',
    usedBonusAmount: 'Χρησιμοποιημένο ποσό μπόνους',
    bonusCategoryA: 'Κατηγορία μπόνους Α',
    bonusCategoryB: 'Κατηγορία μπόνους Β',
    wagerMultiplier: 'Πολλαπλασιαστής στοιχήματος',
    amountWageredIndicator: 'Δείκτης ποσού που στοιχηματίστηκε',
    otherWageringRequirements: 'Άλλες απαιτήσεις στοιχηματισμού',
    onlineAccounts: 'Online λογαριασμοί',
    accountType: 'Τύπος λογαριασμού',
    accountStatusDate: 'Ημερομηνία κατάστασης λογαριασμού',
    accountStatusReason: 'Λόγος κατάστασης λογαριασμού',
    surname: 'Επώνυμο',
    idNumber: 'Αναγνωριστικός αριθμός',
    passportNumber: 'Αριθμός διαβατηρίου',
    vatNumber: 'ΑΦΜ',
    amkaNumber: 'Αριθμός ΑΜΚΑ',
    addressCountry: 'Χώρα διεύθυνσης',
    postCode: 'Ταχυδρομικός κώδικας',
    emailAddress: 'Διεύθυνση email',
    kycDate: 'Ημερομηνία επαλήθευσης KYC',
    playersBetting: 'Στοιχήματα παίκτη',
    eventId: 'Αναγνωριστικό γεγονότος',
    betSettledPeriod: 'Περίοδος διευθέτησης στοιχήματος',
    betTypeB: 'Τύπος στοιχήματος Β',
    betStatus: 'Κατάσταση στοιχήματος',
    betIp: 'Διεύθυνση IP στοιχήματος',
    playerRisk: 'Κίνδυνος παίκτη',
    betIdOdds: 'Αναγνωριστικό αποδόσεων παίκτη',
    betEventId: 'Αναγνωριστικό γεγονότος στοιχήματος',
    betEventName: 'Όνομα γεγονότος στοιχήματος',
    betEventOdds: 'Αποδόσεις γεγονότος στοιχήματος',
    betPlacedDate: 'Ημερομηνία τοποθέτησης στοιχήματος',
    betSettlementDate: 'Ημερομηνία διευθέτησης στοιχήματος',
    netAmountWon: 'Καθαρό ποσό που κερδήθηκε',
    withholdingTax2_5: 'Φόρος που παρακρατήθηκε 2,5%',
    withholdingTax5: 'Φόρος που παρακρατήθηκε 5%',
    withholdingTax7_5: 'Φόρος που παρακρατήθηκε 7.5%',
    realMoneyWagers: 'Στοιχήματα με πραγματικά χρήματα',
    nonRedeemableBonuses: 'Μη εξαργυρώσιμα μπόνους',
    realMoneyWinnings: 'Κέρδη σε πραγματικά χρήματα',
    winningsFromNonRedeemableBonuses: 'Κέρδη από μη εξαργυρώσιμα μπόνους',
    bettingPerformance: 'Επίδοση στοιχήματος',
    domainName: 'Όνομα τομέα',
    betType: 'Τύπος πονταρίσματος',
    totalNumberWagers: 'Συνολικός αριθμός στοιχημάτων',
    totalNumberWagersSettled: 'Συνολικός αριθμός στοιχημάτων που διευθετήθηκε',
    totalNonRedeemableBonusAmountWageredSettled: 'Συνολικό ποσό μη εξαργυρώσιμων μπόνους που στοιχηματίστηκε και διευθετήθηκε',
    recordType: 'Τύπος καταγραφής',
    gamePerformanceDaily: 'Επιδόσεις παιχνιδιού ημερησίως',
    sharedLiquidityIndicator: 'Κοινοποιημένος δείκτης ρευστότητας',
    totalNumberGameSessions: 'Συνολικός αριθμός συνεδριών παιχνιδιού',
    totalNumberPokerCashGamesHands: 'Συνολικός αριθμός χεριών σε παιχνίδια πόκερ με μετρητά',
    totalNumberTaxationSessions: 'Συνολικός αριθμός συνεδριών που φορολογήθηκαν',
    totalNumberJackpots: 'Συνολικός αριθμός τζάκποτ',
    totalNumberIncompleteGameSessions: 'Συνολικός αριθμός μη ολοκληρωμένων συνεδριών παιχνιδιού',
    bettingAndSelfProtection: 'Στοίχημα και αυτοπροστασία',
    jackpotSettings: 'Ρυθμίσεις τζάκποτ',
    jackpotProviderID: 'Αναγνωριστικό παρόχου τζάκποτ',
    profitDistributionLevelCount: 'Αριθμός επιπέδου διανομής κέρδους',
    increaseRate: 'Ρυθμός αύξησης',
    startUpAmount: 'Ποσό έναρξης',
    amountJackpotLimitFloor: 'Κατώτατο όριο ποσού τζάκποτ',
    amountJackpotLimitCeiling: 'Ανώτατο όριο ποσού τζάκποτ',
    timeJackpotLimitCeiling: 'Ανώτατο όριο χρόνου τζάκποτ',
    totalJackpotAmount: 'Συνολικό ποσό τζάκποτ',
    paytableIDCount: 'Αναγνωριστικό αριθμού πίνακα πληρωμών',
    paytableID: 'Αναγνωριστικό πίνακα πληρωμών',
    jackpotEndDate: 'Ημερομηνία λήξης τζάκποτ',
    jackpotTransferedAmount: 'Ποσό τζάκποτ που μεταφέρθηκε',
    oldProfitDistributionLevelID: 'Παλιό αναγνωριστικό επιπέδου διανομής κέρδους',
    newJackpotID: 'Νέο αναγνωριστικό τζάκποτ',
    newProfitDistributionLevelID: 'Νέο αναγνωριστικό επιπέδου διανομής κέρδους',
    jackpotTransferredDate: 'Ημερομηνία μεταφοράς τζάκποτ',
    jackpotStartDate: 'Ημερομηνία έναρξης τζάκποτ',
    totalExclusionCount: 'Συνολικός αριθμός αυτοαποκλεισμών',
    taxAmountPercent: 'Ποσό φόρου ({{percent}}%)',
    totalBalances: 'Συνολικά υπόλοιπά',
    companyProfit: 'Κέρδη εταιρείας',
    balanceAvailable: 'Διαθέσιμο υπόλοιπο',
    nonRedeemableBonusAmountWagered: 'Ποσό μη εξαργυρώσιμων μπόνους που στοιχηματίστηκε',
    totalWithholdingTax: 'Συνολικός φόρος που παρακρατήθηκε',
    nonRedeemableBonusAmountWon: 'Ποσό μη εξαργυρώσιμων μπόνους που κερδήθηκε',
    minimumWagerAmount: 'Ελάχιστο ποσό στοιχήματος',
    withholdingTax15: 'Φόρος που παρακρατήθηκε 15%',
    withholdingTax20: 'Φόρος που παρακρατήθηκε 20%',
    addServer: 'Προσθήκη διακομιστή',
    ggrTaxAmount15: 'Ποσό φόρου GGR (15%)',
    addChange: 'Προσθήκη αλλαγής',
    tournament: 'Τουρνουά',
    stake: 'Ποντάρισμα',
    mainEvent: 'Κύριο παιχνίδι',
    total: 'Σύνολο',
  },
};
